import React from 'react';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 2.5c5.238 0 9.5 4.262 9.5 9.5s-4.262 9.5-9.5 9.5-9.5-4.262-9.5-9.5S6.762 2.5 12 2.5M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.126 11.25h-5.417V6h-1.5v5.25H6.126v1.5h5.083V18h1.5v-5.25h5.417z"
});

function SvgAddCircle(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var _ref$1 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.75 20.083H1.25V6.407h5.634l1.333-2.491h7.565l1.333 2.491h5.634v13.676zm-20-1.5h18.5V7.907h-5.033l-1.333-2.491H9.116L7.783 7.907H2.75v10.676z"
});

var _ref2$1 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 16.583c-2.068 0-3.75-1.682-3.75-3.75s1.682-3.75 3.75-3.75 3.75 1.682 3.75 3.75-1.682 3.75-3.75 3.75zm0-6c-1.241 0-2.25 1.009-2.25 2.25s1.009 2.25 2.25 2.25 2.25-1.009 2.25-2.25-1.009-2.25-2.25-2.25z"
});

function SvgAddPhoto(props) {
  return React.createElement("svg", _extends$1({
    viewBox: "0 0 24 24"
  }, props), _ref$1, _ref2$1);
}

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var _ref$2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.75 21.599l-6.238-5.184v4.336H1.25V3.25h15.262v4.336l6.238-5.184v19.197zm-20-2.349h12.262v-6.033l6.238 5.184V5.598l-6.238 5.184V4.75H2.75v14.5z"
});

function SvgAddVideoMedia(props) {
  return React.createElement("svg", _extends$2({
    viewBox: "0 0 24 24"
  }, props), _ref$2);
}

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var _ref$3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.556 3.418l-2.095.167-.039 7.423-7.448-.046.167 2.095 7.27.038-.038 7.341 2.08-.175.043-7.155 7.497.039-.176-2.08-7.308-.044z"
});

function SvgAdd(props) {
  return React.createElement("svg", _extends$3({
    viewBox: "0 0 24 24"
  }, props), _ref$3);
}

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var _ref$4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 13.438c-2.183 0-3.959-1.794-3.959-4s1.776-4 3.959-4 3.959 1.794 3.959 4-1.776 4-3.959 4zm0-6.5c-1.356 0-2.459 1.122-2.459 2.5s1.104 2.5 2.459 2.5 2.459-1.122 2.459-2.5-1.103-2.5-2.459-2.5z"
});

var _ref2$2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 22.75c-2.684 0-8.04-9.516-8.083-13.324v-.027-.019C3.943 4.968 7.633 1.25 12 1.25c4.306 0 8.083 3.821 8.083 8.176v.954c0 2.677-5.491 12.37-8.083 12.37zM5.417 9.401c.02 3.855 5.357 11.723 6.589 11.849 1.284-.163 6.577-8.358 6.577-10.87v-.954c0-3.151-2.815-6.676-6.583-6.676-3.498 0-6.569 3.105-6.583 6.651z"
});

function SvgAddress(props) {
  return React.createElement("svg", _extends$4({
    viewBox: "0 0 24 24"
  }, props), _ref$4, _ref2$2);
}

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var _ref$5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm2.695 11.204c.221.097.439.207.654.332l2.482 1.479-1.224 2.023-2.482-1.479a7.208 7.208 0 01-.595-.382 3.9 3.9 0 01-.51-.434c.147.397.221.833.221 1.309v2.975h-2.482v-2.941c0-.227.014-.456.042-.688s.077-.445.145-.638c-.147.159-.312.3-.493.425s-.374.249-.578.374l-2.482 1.445-1.224-2.023 2.482-1.445c.215-.125.431-.232.646-.323.215-.091.436-.159.663-.204a3.102 3.102 0 01-.663-.212 7.065 7.065 0 01-.646-.332L6.169 9.986l1.224-2.04 2.482 1.496c.204.125.399.252.586.382.187.13.354.275.501.434a3.918 3.918 0 01-.204-1.309V5.973h2.482v2.941c0 .238-.014.47-.042.697a3.323 3.323 0 01-.145.646c.147-.159.312-.303.493-.434.181-.13.374-.257.578-.382l2.482-1.462 1.224 2.04-2.482 1.445a7.163 7.163 0 01-.663.323 3.428 3.428 0 01-.663.204c.228.046.451.117.673.213z"
});

function SvgAsterisk(props) {
  return React.createElement("svg", _extends$5({
    viewBox: "0 0 24 24"
  }, props), _ref$5);
}

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

var _ref$6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.212 22.746a6.266 6.266 0 01-4.371-1.75l-9.769-9.459a5.902 5.902 0 01.001-8.532c2.411-2.334 6.333-2.334 8.742 0l6.351 6.149-1.043 1.078-6.351-6.149c-1.835-1.776-4.819-1.776-6.655 0A4.404 4.404 0 002.75 7.27c0 1.203.485 2.335 1.366 3.188l9.769 9.459c1.835 1.775 4.819 1.777 6.655 0l1.043 1.078a6.272 6.272 0 01-4.371 1.751z"
});

var _ref2$3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.372 21.199l-1.044-1.077.342-.332c.374-.361.579-.84.579-1.348 0-.508-.206-.987-.579-1.348l-8.01-7.758a2.067 2.067 0 00-2.854 0c-.374.362-.579.84-.579 1.348s.206.986.579 1.348l6.355 6.154-1.043 1.077-6.355-6.153c-.668-.646-1.036-1.508-1.036-2.425s.368-1.779 1.036-2.425c1.361-1.319 3.578-1.319 4.94 0l8.012 7.757c.668.646 1.036 1.508 1.036 2.426s-.368 1.779-1.036 2.425l-.343.331z"
});

function SvgAttach(props) {
  return React.createElement("svg", _extends$6({
    viewBox: "0 0 24 24"
  }, props), _ref$6, _ref2$3);
}

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

var _ref$7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.119 3.96H3.699l1.327-1.455-1.109-1.01L.985 4.71l2.932 3.216 1.108-1.011L3.699 5.46h10.42c3.932 0 7.131 3.542 7.131 7.895 0 4.354-3.199 7.895-7.131 7.895h-3.917v1.5h3.917c4.759 0 8.631-4.214 8.631-9.395 0-5.18-3.872-9.395-8.631-9.395z"
});

function SvgBack(props) {
  return React.createElement("svg", _extends$7({
    viewBox: "0 0 24 24"
  }, props), _ref$7);
}

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

var _ref$8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#CB3A28",
  d: "M12 22.392L0 1.608s5.188 5.83 12 5.83c6.688 0 12-5.83 12-5.83L12 22.392z"
});

function SvgBadgeDown(props) {
  return React.createElement("svg", _extends$8({
    viewBox: "0 0 24 24"
  }, props), _ref$8);
}

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

var _ref$9 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#72B543",
  d: "M12 1.608L0 22.392s5.188-5.83 12-5.83c6.688 0 12 5.83 12 5.83L12 1.608z"
});

function SvgBadgeUp(props) {
  return React.createElement("svg", _extends$9({
    viewBox: "0 0 24 24"
  }, props), _ref$9);
}

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

var _ref$a =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 11.778c-3.627 0-5.221 2.735-5.287 2.852l-.21.37.21.37c.066.116 1.66 2.852 5.287 2.852s5.221-2.735 5.287-2.852l.21-.37-.21-.37c-.066-.116-1.66-2.852-5.287-2.852zm0 4.944c-2.037 0-3.224-1.118-3.716-1.722.492-.604 1.679-1.722 3.716-1.722 2.039 0 3.226 1.12 3.717 1.722-.493.604-1.68 1.722-3.717 1.722z"
});

var _ref2$4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 14.024a.976.976 0 100 1.952.976.976 0 000-1.952z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.58 4.529V2h-1.5v2.529H6.92V2h-1.5v2.529H1.25V22.75h21.5V4.529h-4.17zm-13.16 1.5v1.116h1.5V6.029h10.16v1.116h1.5V6.029h2.669v2.797H2.75V6.029h2.67zM2.75 21.25V10.326h18.5V21.25H2.75z"
});

function SvgCalendarView(props) {
  return React.createElement("svg", _extends$a({
    viewBox: "0 0 24 24"
  }, props), _ref$a, _ref2$4, _ref3);
}

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

var _ref$b =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.581 4.529V2h-1.5v2.529H6.92V2h-1.5v2.529H1.25V22.75h21.5V4.529h-4.169zM5.42 6.029v1.116h1.5V6.029h10.161v1.116h1.5V6.029h2.669v2.797H2.75V6.029h2.67zM2.75 21.25V10.326h18.5V21.25H2.75z"
});

var _ref2$5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.785 12.127h2.124v2.124H6.785zM10.938 12.127h2.124v2.124h-2.124zM15.092 12.127h2.124v2.124h-2.124zM6.785 16.508h2.124v2.124H6.785zM10.938 16.508h2.124v2.124h-2.124zM15.092 16.508h2.124v2.124h-2.124z"
});

function SvgCalendar(props) {
  return React.createElement("svg", _extends$b({
    viewBox: "0 0 24 24"
  }, props), _ref$b, _ref2$5);
}

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

var _ref$c =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.5 2.5v19h-19v-19h19M23 1H1v22h22V1z"
});

var _ref2$6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.735 14.791l-3.443-3.706L5 12.095l4.68 5.038L19 7.927l-1.244-1.06z"
});

function SvgCheckboxChecked(props) {
  return React.createElement("svg", _extends$c({
    viewBox: "0 0 24 24"
  }, props), _ref$c, _ref2$6);
}

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

var _ref$d =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.5 2.5v19h-19v-19h19M23 1H1v22h22V1z"
});

function SvgCheckboxUnchecked(props) {
  return React.createElement("svg", _extends$d({
    viewBox: "0 0 24 24"
  }, props), _ref$d);
}

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

var _ref$e =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1z"
});

function SvgCircle(props) {
  return React.createElement("svg", _extends$e({
    viewBox: "0 0 24 24"
  }, props), _ref$e);
}

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

var _ref$f =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.53 15.252l-1.06-1.061-2.646 2.646-2.645-2.646-1.06 1.061 2.645 2.645-2.646 2.646 1.061 1.06 2.645-2.645 2.646 2.645 1.06-1.06-2.645-2.646z"
});

var _ref2$7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.979 15.389H4.024l.001-5.828h2.777l.752-1.03h9.069v4.689h2.2V6.333h-9.74l-.82-1.304H1.828l-.004 12.56h12.155v-2.2zm-9.953-8.16h1.756l-.097.132H4.026v-.132z"
});

function SvgCloseAllTabs(props) {
  return React.createElement("svg", _extends$f({
    viewBox: "0 0 24 24"
  }, props), _ref$f, _ref2$7);
}

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

var _ref$g =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.789 6.651l-1.6-1.363-5.276 5.222-5.234-5.299-1.363 1.6 5.113 5.167-5.218 5.164 1.595 1.346 5.09-5.028 5.273 5.329 1.347-1.595-5.136-5.199z"
});

function SvgClose(props) {
  return React.createElement("svg", _extends$g({
    viewBox: "0 0 24 24"
  }, props), _ref$g);
}

function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

var _ref$h =
/*#__PURE__*/
React.createElement("path", {
  d: "M1 10h22v4H1z"
});

function SvgCollapseMinus(props) {
  return React.createElement("svg", _extends$h({
    viewBox: "0 0 24 24"
  }, props), _ref$h);
}

function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

var _ref$i =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.073 14.343l-4.407 4.407.001-16.052h-1.333l-.001 16.052-4.407-4.407-.942.943L12 21.302l6.016-6.016z"
});

function SvgColumnSortDown(props) {
  return React.createElement("svg", _extends$i({
    viewBox: "0 0 24 24"
  }, props), _ref$i);
}

function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

var _ref$j =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.927 9.657l4.407-4.407-.001 16.052h1.333l.001-16.052 4.407 4.407.942-.943L12 2.698 5.984 8.714z"
});

function SvgColumnSortUp(props) {
  return React.createElement("svg", _extends$j({
    viewBox: "0 0 24 24"
  }, props), _ref$j);
}

function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

var _ref$k =
/*#__PURE__*/
React.createElement("path", {
  xmlns: "http://www.w3.org/2000/svg",
  d: "M22 9H2a1 1 0 110-2h20a1 1 0 110 2zM22 17H2a1 1 0 110-2h20a1 1 0 110 2z"
});

function SvgColumnHandle(props) {
  return React.createElement("svg", _extends$k({
    viewBox: "0 0 24 24"
  }, props), _ref$k);
}

function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

var _ref$l =
/*#__PURE__*/
React.createElement("path", {
  fill: "#CCC",
  d: "M58.145 40.044c.051 0 .558.003.588.001 1.489.34 1.782 1.16 1.775 2.924.007 1.81-.763 2.959-3.556 2.959-1.489 8.38-9.003 13.545-16.742 13.545-7.681 0-13.563-3.823-16.159-13.543-3.404.014-3.543-.994-3.542-2.96 0-1.584.31-2.107.843-2.618.208-.2.488-.308.776-.307l.152.001c0-10.881 8.302-18.909 18.229-18.909s17.636 8.026 17.636 18.907z"
});

var _ref2$8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#999",
  d: "M39.327 33.596c-1.103 3.749-2.38 8.474-3.524 12.938 1.686-.036 2.311-.025 4.705 0v12.938c-7.681 0-13.862-3.823-16.458-13.543-3.404.014-3.543-.994-3.542-2.96 0-1.646.335-2.146.906-2.678a.906.906 0 01.618-.247l.247.001c0-10.881 8.302-18.909 18.229-18.909.436.055 2.274 2.242-1.181 12.46z"
});

var _ref3$1 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#333",
  d: "M25.213 40.016l-2.941.012v-7.03s0-3.299 1.746-5.872c1.599-2.555 2.615-3.309 3.565-4.153 1.032-.917 2.282-1.78 3.547-2.334 1.286-.588 1.517-.69 3.51-1.176 1.515-.302 2.408-.583 5.826-.582 3.199.188 4.062.278 5.333.565 3.549 1.076 4.076 1.266 7.072 3.527 1.691 1.25 2.411 2.154 2.922 2.977 1.048 1.434 1.351 2.077 1.875 4.089.276.744.478 2.319.478 2.319v7.679l-2.94-.009v-5.256s-1.966.57-5.863-3.538c-3.878-3.997-3.859-7.654-3.859-7.654h-.046s.23 3.712-4.948 7.643c-3.993 3.917-9.956 3.513-9.956 3.513l-5.321-.024v5.304z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#333",
  d: "M49.018 39.146a1.764 1.764 0 11-3.529 0 1.764 1.764 0 013.529 0zM34.622 39.146a1.764 1.764 0 11-3.529 0 1.764 1.764 0 013.529 0z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#666",
  d: "M45.833 50.1c0 .907-1.955 4.014-5.325 4.014s-5.886-3.107-5.886-4.014 2.516 1.062 5.886 1.062 5.325-1.969 5.325-1.062z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#666",
  d: "M40 5.5c19.023 0 34.5 15.477 34.5 34.5S59.023 74.5 40 74.5 5.5 59.023 5.5 40 20.977 5.5 40 5.5m0-5C18.185.5.5 18.185.5 40S18.185 79.5 40 79.5 79.5 61.815 79.5 40 61.815.5 40 .5z"
});

function SvgDefaultUserImage(props) {
  return React.createElement("svg", _extends$l({
    viewBox: "0 0 80 80"
  }, props), _ref$l, _ref2$8, _ref3$1, _ref4, _ref5, _ref6);
}

function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

var _ref$m =
/*#__PURE__*/
React.createElement("path", {
  d: "M20 3.917h-4.825V1.25H8.826v2.667H4v1.5h.947V22.75h14.106V5.417H20v-1.5zM10.326 2.75h3.349v1.167h-3.349V2.75zm7.227 18.5H6.447V5.417h11.106V21.25z"
});

var _ref2$9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.018 8.091h1.5v10.277h-1.5zM11.25 8.091h1.5v10.277h-1.5zM14.482 8.091h1.5v10.277h-1.5z"
});

function SvgDelete(props) {
  return React.createElement("svg", _extends$m({
    viewBox: "0 0 24 24"
  }, props), _ref$m, _ref2$9);
}

function _extends$n() { _extends$n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

var _ref$n =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.679 21.75H6.465v-1.5h2.214v1.5zM4.25 21.75h-2v-2h1.5v.5h.5zM3.75 17.536h-1.5v-2.214h1.5v2.214zm0-4.429h-1.5v-2.214h1.5v2.214zm0-4.428h-1.5V6.464h1.5v2.215zM3.75 4.25h-1.5v-2h2v1.5h-.5zM17.535 3.75h-2.214v-1.5h2.214v1.5zm-4.428 0h-2.214v-1.5h2.214v1.5zm-4.429 0H6.464v-1.5h2.214v1.5zM21.75 4.25h-1.5v-.5h-.5v-1.5h2zM21.75 8.679h-1.5V6.464h1.5v2.215zM6.5 6.24h11v1.5h-11zM6.5 9.245h11v1.5h-11zM6.5 12.25h3.629v1.5H6.5zM22.535 13.597l-1.178-1.004-3.886 3.846-3.855-3.903-1.004 1.178 3.766 3.806-3.843 3.803 1.175.991 3.748-3.703 3.884 3.925.992-1.175-3.783-3.829z"
});

function SvgDeselectAll(props) {
  return React.createElement("svg", _extends$n({
    viewBox: "0 0 24 24"
  }, props), _ref$n);
}

function _extends$o() { _extends$o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

var _ref$o =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  d: "M.5 16.5h6v6h-6zM8.5 16.5h6v6h-6zM16.5 16.5h6v6h-6zM.5 8.5h6v6h-6zM8.5 8.5h6v6h-6zM16.5 8.5h6v6h-6zM.5.5h6v6h-6zM8.5.5h6v6h-6zM16.5.5h6v6h-6z"
});

function SvgDetailView(props) {
  return React.createElement("svg", _extends$o({
    viewBox: "0 0 24 24"
  }, props), _ref$o);
}

function _extends$p() { _extends$p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

var _ref$p =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.5 14.276V21.5h-19v-19h7.224V1H1v22h22v-8.724z"
});

var _ref2$a =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.144 2.417l-1.06-1.061L10.5 11.94V6.946H9V14.5h7.126V13h-4.565z"
});

function SvgDock(props) {
  return React.createElement("svg", _extends$p({
    viewBox: "0 0 24 24"
  }, props), _ref$p, _ref2$a);
}

function _extends$q() { _extends$q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

var _ref$q =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.25 5.75v12.5h21.5V5.75H1.25zm20 3.357h-.542c-.733 0-1.33-.597-1.33-1.33V7.25h1.872v1.857zm-3.271 6.365h-1.998v1.278H8.019v-1.278H6.021a2.843 2.843 0 00-1.979-1.979v-2.987a2.843 2.843 0 001.979-1.979h1.998V7.25h7.961v1.278h1.998a2.843 2.843 0 001.979 1.979v2.987a2.84 2.84 0 00-1.978 1.978zM4.622 7.25v.528c0 .733-.597 1.33-1.33 1.33H2.75V7.25h1.872zM2.75 14.893h.543c.733 0 1.33.597 1.33 1.33v.528H2.75v-1.858zm16.628 1.857v-.528c0-.733.597-1.33 1.33-1.33h.542v1.857h-1.872z"
});

var _ref2$b =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.005 8.986c-1.665 0-3.019 1.354-3.019 3.019s1.354 3.019 3.019 3.019 3.019-1.354 3.019-3.019-1.355-3.019-3.019-3.019zm0 4.537c-.837 0-1.519-.682-1.519-1.519s.682-1.519 1.519-1.519 1.519.681 1.519 1.519-.682 1.519-1.519 1.519zM17.614 10.75a1.255 1.255 0 10.001 2.51 1.255 1.255 0 00-.001-2.51zm-.246 1.254a.246.246 0 01.492 0c0 .273-.492.272-.492 0zM6.396 10.75a1.255 1.255 0 10.001 2.51 1.255 1.255 0 00-.001-2.51zm-.246 1.254a.246.246 0 01.492 0c0 .273-.492.272-.492 0z"
});

function SvgDollar(props) {
  return React.createElement("svg", _extends$q({
    viewBox: "0 0 24 24"
  }, props), _ref$q, _ref2$b);
}

function _extends$r() { _extends$r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

var _ref$r =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.017 18.6L21 6.763 19.401 5.4 9.087 15.589l-4.426-4.766L3 12.122z"
});

function SvgDone(props) {
  return React.createElement("svg", _extends$r({
    viewBox: "0 0 24 24"
  }, props), _ref$r);
}

function _extends$s() { _extends$s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

var _ref$s =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 8.409l7 7.375H5z"
});

function SvgDropDownReverse(props) {
  return React.createElement("svg", _extends$s({
    viewBox: "0 0 24 24"
  }, props), _ref$s);
}

function _extends$t() { _extends$t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

var _ref$t =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.784l7-7.375H5z"
});

function SvgDropDown(props) {
  return React.createElement("svg", _extends$t({
    viewBox: "0 0 24 24"
  }, props), _ref$t);
}

function _extends$u() { _extends$u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

var _ref$u =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.75 22.75H1.25V1.25h13.854v1.5H2.75v18.5h18.5V8.66h1.5z"
});

var _ref2$c =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.364 15.049l.13-3.923 9.479-9.217c1.365-1.326 2.714-.015 3.292.546.586.57 1.16 1.193 1.16 1.978 0 .464-.202.895-.599 1.281l-9.471 9.209-3.991.126zm1.61-3.268L9.916 13.5l1.81-.057 9.054-8.804c.114-.111.145-.182.145-.206 0-.144-.237-.447-.706-.902-.881-.855-.994-.745-1.2-.546l-9.045 8.796z"
});

function SvgEdit(props) {
  return React.createElement("svg", _extends$u({
    viewBox: "0 0 24 24"
  }, props), _ref$u, _ref2$c);
}

function _extends$v() { _extends$v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

var _ref$v =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.25 3.25v17.5h11.873v-1.5H3.652l6.671-7.631L12 12.96l1.652-1.332 1.494 1.356 1.075-.854-1.468-1.372L21.25 5.56v6.147h1.5V3.25H1.25zm1.5 14.753V5.56l6.401 5.121-6.401 7.322zM4.138 4.75h15.724L12 11.04 4.138 4.75z"
});

var _ref2$d =
/*#__PURE__*/
React.createElement("path", {
  d: "M23 21.24l-2.858-2.844c.28-.467.451-1.006.451-1.589 0-1.712-1.389-3.105-3.096-3.105s-3.096 1.393-3.096 3.105 1.389 3.104 3.096 3.104c.582 0 1.121-.172 1.586-.453l2.854 2.839L23 21.24zm-5.503-2.829c-.88 0-1.596-.72-1.596-1.604s.716-1.605 1.596-1.605 1.596.72 1.596 1.605-.717 1.604-1.596 1.604z"
});

function SvgEmailReadRecipient(props) {
  return React.createElement("svg", _extends$v({
    viewBox: "0 0 24 24"
  }, props), _ref$v, _ref2$d);
}

function _extends$w() { _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

var _ref$w =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.25 3.25v17.5h11.873v-1.5H3.652l6.671-7.631L12 12.96l1.652-1.332 1.494 1.356 1.075-.854-1.468-1.372L21.25 5.56v6.147h1.5V3.25H1.25zm1.5 14.753V5.56l6.401 5.121-6.401 7.322zM4.138 4.75h15.724L12 11.04 4.138 4.75z"
});

var _ref2$e =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.956 14.044c-3.328 0-4.791 2.51-4.851 2.617l-.193.339.193.34c.06.107 1.523 2.617 4.851 2.617 3.329 0 4.791-2.51 4.852-2.617L24 17l-.193-.34c-.06-.106-1.523-2.616-4.851-2.616zm0 4.536c-1.869 0-2.959-1.026-3.41-1.58.452-.554 1.541-1.58 3.41-1.58 1.871 0 2.96 1.027 3.411 1.58-.452.554-1.542 1.58-3.411 1.58z"
});

var _ref3$2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.956 16.105a.895.895 0 100 1.79.895.895 0 000-1.79z"
});

function SvgEmailRead(props) {
  return React.createElement("svg", _extends$w({
    viewBox: "0 0 24 24"
  }, props), _ref$w, _ref2$e, _ref3$2);
}

function _extends$x() { _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

var _ref$x =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.25 3.25v17.5h11.873v-1.5H3.652l6.671-7.631L12 12.96l1.652-1.332 1.494 1.356 1.075-.854-1.468-1.372L21.25 5.56v6.147h1.5V3.25H1.25zm1.5 14.753V5.56l6.401 5.121-6.401 7.322zM4.138 4.75h15.724L12 11.04 4.138 4.75z"
});

var _ref2$f =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.956 13a4 4 0 100 8 4 4 0 000-8z"
});

function SvgEmailUnread(props) {
  return React.createElement("svg", _extends$x({
    viewBox: "0 0 24 24"
  }, props), _ref$x, _ref2$f);
}

function _extends$y() { _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

var _ref$y =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.25 3.25v17.5h21.5V3.25H1.25zM12 11.239c-.9-.295-4.54-3.31-8.065-6.489h16.129C16.54 7.929 12.9 10.944 12 11.239zm-3.008-.228L2.75 18.028V5.703c1.952 1.772 4.338 3.865 6.242 5.308zm1.224.881c.797.534 1.428.858 1.784.858.355 0 .986-.325 1.784-.858l6.545 7.358H3.671l6.545-7.358zm4.792-.881c1.904-1.443 4.29-3.536 6.242-5.307v12.325l-6.242-7.018z"
});

function SvgEmail(props) {
  return React.createElement("svg", _extends$y({
    viewBox: "0 0 24 24"
  }, props), _ref$y);
}

function _extends$z() { _extends$z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

var _ref$z =
/*#__PURE__*/
React.createElement("path", {
  d: "M4 7h16v2.95H4zM4 14h16v2.95H4z"
});

function SvgEquals(props) {
  return React.createElement("svg", _extends$z({
    viewBox: "0 0 24 24"
  }, props), _ref$z);
}

function _extends$A() { _extends$A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

var _ref$A =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.473 20.317l9.057-9.057-1.061-1.061-8.199 8.199-3.304-3.304 8.308-8.308-1.061-1.061-8.308 8.308-3.304-3.303 8.2-8.199L12.74 1.47l-9.26 9.26-1.107 1.106a3.84 3.84 0 000 5.425l4.365 4.365a3.824 3.824 0 002.713 1.122c.053 0 .106-.013.159-.015v.017H22v-1.5h-9.46l.933-.933zm-5.674.249l-4.365-4.365a2.339 2.339 0 010-3.304l1.107-1.106 7.669 7.669-1.106 1.107a2.342 2.342 0 01-3.305-.001z"
});

function SvgErase(props) {
  return React.createElement("svg", _extends$A({
    viewBox: "0 0 24 24"
  }, props), _ref$A);
}

function _extends$B() { _extends$B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

var _ref$B =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.556 1H7.444L1 7.444v9.113L7.444 23h9.113L23 16.556V7.444L16.556 1zm-3.257 18.992h-2.597v-2.887h2.597v2.887zm0-4.44h-2.597L9.505 4.92a.82.82 0 01.815-.912h3.359a.82.82 0 01.815.912l-1.195 10.632z"
});

function SvgError(props) {
  return React.createElement("svg", _extends$B({
    viewBox: "0 0 24 24"
  }, props), _ref$B);
}

function _extends$C() { _extends$C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

var _ref$C =
/*#__PURE__*/
React.createElement("path", {
  d: "M23 10h-9V1h-4v9H1v4h9v9h4v-9h9z"
});

function SvgExpandPlus(props) {
  return React.createElement("svg", _extends$C({
    viewBox: "0 0 24 24"
  }, props), _ref$C);
}

function _extends$D() { _extends$D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

var _ref$D =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.361 17.7l5.7-5.7-5.7-5.699-1.06 1.06 3.888 3.889H5.52v1.5h14.67l-3.889 3.889z"
});

var _ref2$g =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.25 21.25H2.75V2.75h18.5v3.07h1.5V1.25H1.25v21.5h21.5v-4.57h-1.5z"
});

function SvgExpand(props) {
  return React.createElement("svg", _extends$D({
    viewBox: "0 0 24 24"
  }, props), _ref$D, _ref2$g);
}

function _extends$E() { _extends$E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

var _ref$E =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M19.25 21.171V8.913h-6.515V2.829H4.75v18.342H16.5z"
});

var _ref2$h =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M14.235 7.413h3.836l-3.836-3.757z"
});

var _ref3$3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.003 1.329H3.25V22.67H7.5v-1.5H4.75V2.829h7.985v6.083h6.515V21.17H16.5v1.5h4.25V7.937l-6.747-6.608zm.232 6.084V3.656l3.836 3.757h-3.836z"
});

var _ref4$1 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.004 22.423a.58.58 0 00.41-.17l3.09-3.09-.819-.819-2.101 2.101v-8.444h-1.159v8.444l-2.101-2.101-.819.819 3.09 3.09c.113.113.261.17.409.17z"
});

function SvgExport(props) {
  return React.createElement("svg", _extends$E({
    viewBox: "0 0 24 24"
  }, props), _ref$E, _ref2$h, _ref3$3, _ref4$1);
}

function _extends$F() { _extends$F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

var _ref$F =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.499 3.509A2.254 2.254 0 007.377 2c-.983 0-1.811.632-2.121 1.509H1.678v1.5h3.578c.31.877 1.138 1.508 2.121 1.508s1.811-.632 2.121-1.508h12.824v-1.5H9.499zM8.989 17.483c-.983 0-1.811.632-2.121 1.509H2.246v1.5h4.622C7.179 21.368 8.006 22 8.989 22s1.811-.632 2.121-1.508h11.212v-1.5H11.111a2.253 2.253 0 00-2.122-1.509zM17.123 9.322a2.252 2.252 0 00-2.225 1.928H1.678v1.5H15.2c.396.651 1.106 1.089 1.923 1.089s1.527-.438 1.923-1.089h3.276v-1.5h-2.974a2.252 2.252 0 00-2.225-1.928z"
});

function SvgFilter(props) {
  return React.createElement("svg", _extends$F({
    viewBox: "0 0 24 24"
  }, props), _ref$F);
}

function _extends$G() { _extends$G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

var _ref$G =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.458 14.47l4.939-4.94-4.939-4.939"
});

var _ref2$i =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.567 19.409H3.603c0-6.264 5.096-11.36 11.36-11.36h2.982v2.964h-2.982c-4.63-.001-8.396 3.766-8.396 8.396z"
});

function SvgForward(props) {
  return React.createElement("svg", _extends$G({
    viewBox: "0 0 24 24"
  }, props), _ref$G, _ref2$i);
}

function _extends$H() { _extends$H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

var _ref$H =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.146 15.999v6.855h6.855v-1.276H3.324l6.822-6.822-.902-.902-6.822 6.822-.001-4.677zM22.854 15.999v6.855h-6.855v-1.276h4.677l-6.822-6.822.902-.902 6.822 6.822.001-4.677zM1.146 8.001V1.146h6.855v1.276H3.324l6.822 6.822-.902.902-6.822-6.822-.001 4.677zM22.854 8.001V1.146h-6.855v1.276h4.677l-6.822 6.822.902.902 6.822-6.822.001 4.677z"
});

function SvgFullScreen(props) {
  return React.createElement("svg", _extends$H({
    viewBox: "0 0 24 24"
  }, props), _ref$H);
}

function _extends$I() { _extends$I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

var _ref$I =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.25 22.75h5.118v-11.5H1.25v11.5zm1.5-10h2.118v8.5H2.75v-8.5zM17.632 1.25v21.5h5.118V1.25h-5.118zm3.618 20h-2.118V2.75h2.118v18.5zM9.441 22.75h5.118V6.25H9.441v16.5zm1.5-15h2.118v13.5h-2.118V7.75z"
});

function SvgGraphView(props) {
  return React.createElement("svg", _extends$I({
    viewBox: "0 0 24 24"
  }, props), _ref$I);
}

function _extends$J() { _extends$J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

var _ref$J =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.237 19.674v-2.239c0-.187.047-.356.141-.508s.256-.286.49-.402l7.857-3.973c.232-.117.475-.222.727-.315a5.3 5.3 0 01.812-.227 8.58 8.58 0 01-.812-.236 4.682 4.682 0 01-.727-.324L5.868 7.46c-.234-.116-.396-.248-.49-.394s-.141-.319-.141-.517V4.326l13.527 7.018v1.295L5.237 19.674z"
});

function SvgGreaterThan(props) {
  return React.createElement("svg", _extends$J({
    viewBox: "0 0 24 24"
  }, props), _ref$J);
}

function _extends$K() { _extends$K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

var _ref$K =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.201 7.152L9 12l-4.799 4.847-.893-.902 3.274-3.307H0v-1.276h6.582L3.308 8.054zM19.847 16.848L15 12l4.847-4.847.902.902-3.307 3.307H24v1.276h-6.558l3.307 3.308zM10 1h4v22h-4z"
});

function SvgHalfScreen(props) {
  return React.createElement("svg", _extends$K({
    viewBox: "0 0 24 24"
  }, props), _ref$K);
}

function _extends$L() { _extends$L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

var _ref$L =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.629 19.594c-.33-.515-1.157-2.074-1.144-3.274.196-.404.368-.836.512-1.287 1.13-3.527.23-7.342-2.35-9.958a9.547 9.547 0 00-6.843-2.874A9.544 9.544 0 004.96 5.075c-3.767 3.819-3.767 10.034 0 13.854a9.584 9.584 0 006.835 2.874c1.41 0 2.831-.313 4.162-.955 1.826.22 5.108-.295 5.252-.317l.926-.147-.506-.79zm-1.486-.152c-1.138.145-3.106.344-4.189.168l-.197-.033-.179.09c-3.253 1.655-7.173 1.01-9.746-1.6-3.299-3.345-3.299-8.789 0-12.134a8.334 8.334 0 015.972-2.509c2.255 0 4.375.891 5.971 2.509 2.258 2.29 3.045 5.633 2.055 8.725a8.58 8.58 0 01-.5 1.233l-.064.238c-.07 1.181.464 2.492.877 3.313z",
  stroke: "currentColor",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref2$j =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.314 15.065a.646.646 0 00-.478-.198.706.706 0 00-.267.052.631.631 0 00-.214.146.719.719 0 00-.141.217.697.697 0 00.141.747.687.687 0 00.481.195.665.665 0 00.622-.409.68.68 0 00.053-.269.666.666 0 00-.053-.264.709.709 0 00-.144-.217zM13.972 7.194a2.812 2.812 0 00-.951-.505 3.646 3.646 0 00-1.188-.16 4.21 4.21 0 00-.902.11 4.166 4.166 0 00-.771.268 4.238 4.238 0 00-.656.382c-.2.143-.384.293-.551.451l.421.64c.072.121.18.181.324.178.063-.001.146-.042.245-.122.1-.079.229-.167.387-.264.158-.096.351-.186.579-.268.228-.082.502-.126.822-.133a2.1 2.1 0 01.658.086c.205.063.384.157.538.282a1.374 1.374 0 01.515 1.062 1.71 1.71 0 01-.175.836c-.123.238-.277.45-.463.638a4.688 4.688 0 01-.598.512 6.888 6.888 0 00-.586.472 2.235 2.235 0 00-.43.517.963.963 0 00-.115.634l.123 1.326 1.039-.021.128-1.219a.796.796 0 01.23-.48c.136-.144.297-.291.484-.439.186-.148.386-.305.599-.472.213-.167.408-.362.584-.584.177-.223.322-.483.437-.781.114-.298.167-.65.159-1.056-.008-.4-.091-.76-.246-1.079a2.457 2.457 0 00-.64-.811z"
});

function SvgHelp(props) {
  return React.createElement("svg", _extends$L({
    viewBox: "0 0 24 24"
  }, props), _ref$L, _ref2$j);
}

function _extends$M() { _extends$M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

var _ref$M =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.111 2.361c-5.09 0-9.261 3.969-9.605 8.973l-.976-.976-1.06 1.061 2.752 2.753 2.753-2.753-1.061-1.061-.905.905c.374-4.143 3.863-7.402 8.102-7.402 4.488 0 8.139 3.651 8.139 8.139s-3.651 8.139-8.139 8.139a8.1 8.1 0 01-6.384-3.09l-1.176.931a9.592 9.592 0 007.56 3.659c5.315 0 9.639-4.324 9.639-9.639s-4.324-9.639-9.639-9.639zm-8.889 9.69L4.171 12h.102l-.051.051z"
});

var _ref2$k =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.361 5.723v4.339A2.081 2.081 0 0011.028 12c0 1.149.935 2.083 2.083 2.083.884 0 1.636-.555 1.938-1.333H17.4v-1.5h-2.351a2.083 2.083 0 00-1.188-1.188V5.723h-1.5z"
});

function SvgHistory(props) {
  return React.createElement("svg", _extends$M({
    viewBox: "0 0 24 24"
  }, props), _ref$M, _ref2$k);
}

function _extends$N() { _extends$N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

var _ref$N =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.498 10.328L12 .997 1.502 10.328l.996 1.121 1.57-1.396V22.75h6.451v-6.316h2.961v6.316h6.451V10.053l1.571 1.396.996-1.121zM18.431 21.25H14.98v-6.316H9.019v6.316h-3.45V8.752h-.036L12 3.003l6.431 5.716V21.25z"
});

function SvgHome(props) {
  return React.createElement("svg", _extends$N({
    viewBox: "0 0 24 24"
  }, props), _ref$N);
}

function _extends$O() { _extends$O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

var _ref$O =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 5.7c0-.387.32-.7.714-.7h18.571c.395 0 .715.313.715.7v12.6c0 .387-.32.7-.714.7H2.714A.707.707 0 012 18.3V5.7zM20.145 7.675h-7.949M20.145 11.156h-7.949M13.99 14.856H4.494M20.679 14.856h-5.015",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref2$l =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.494 6.876h5.471v5.222H4.494z"
});

function SvgIdentification(props) {
  return React.createElement("svg", _extends$O({
    viewBox: "0 0 24 24"
  }, props), _ref$O, _ref2$l);
}

function _extends$P() { _extends$P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }

var _ref$P =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.42 15.147c-.29-.009-.496.048-.566.324-.073.287.035.509.257.674.476.353 1.01.427 1.586.322 1.138-.207 2.074-.778 2.886-1.576.288-.282.563-.578.854-.856.164-.156.346-.295.525-.433.596-.459 1.223-.423 1.855-.093.13.068.217.082.355.007.637-.343 1.278-.384 1.871.092.353.283.693.589 1.007.916.73.76 1.521 1.424 2.541 1.756.595.193 1.2.358 1.823.116.156-.06.31-.135.446-.23.231-.162.359-.379.29-.68-.066-.288-.276-.347-.539-.342.348-.329 1.002-.178 1.236.278.19.37.171.768.103 1.162-.153.885-.747 1.435-1.468 1.875a3.564 3.564 0 01-1.69.505c-1.331.069-2.636-.064-3.867-.623a4.811 4.811 0 01-1.945-1.601c-.03.061-.043.105-.069.139-.833 1.083-1.96 1.67-3.278 1.921-.743.141-1.494.222-2.252.179-1.228-.069-2.266-.522-2.993-1.548-.39-.55-.478-1.181-.308-1.826a.852.852 0 011.34-.458zM1.064 6.28c-.026-.065.009-.139-.047-.216-.034-.047-.006-.139-.006-.17.072-.258.277-.232.44-.273.119-.03.248-.022.369-.049.11-.026.225-.06.332-.073.218-.027.422-.1.634-.141a3.23 3.23 0 00.352-.087c.116-.036.238-.033.355-.079.085-.032.187-.017.284-.042.153-.04.32-.02.475-.054.196-.043.396-.009.585-.048.148-.031.291-.031.437-.033.431-.004.862-.001 1.293-.002.282-.001.561.073.844.043.154.074.329.004.475.053.169.057.349-.016.506.078.163-.032.317.045.478.045.073 0 .146.027.219.04.073.013.145-.007.224.035.078.041.184.011.282.045.121.042.263.02.388.053.19.05.389.047.576.118.08.03.175.033.26.044.204.025.398.108.61.096.215-.012.431-.003.646-.003h.647c.097 0 .191-.033.282-.052.212-.042.425-.083.636-.128.089-.019.183-.011.261-.042.083-.033.167-.016.242-.041.201-.067.419-.045.616-.126.149.031.288-.045.435-.046.087 0 .175-.026.262-.04.081-.013.171.032.241-.043.003-.004.014-.001.021 0 .199.032.388-.045.586-.047.245-.003.494-.018.735-.048.484-.062.967-.013 1.449-.033.151-.006.302-.006.453.001.109.005.218.032.327.04.107.007.219-.015.322.008.066.015.129.035.199.039.068.004.134-.019.206.024.053.032.141 0 .207.019.188.056.385.074.576.114.212.044.421.099.633.143.118.025.236.053.352.087.116.034.243.021.354.082.028.015.072.01.106.001.102-.026.187.043.284.047.095.004.191.021.284.042.124.03.203.136.209.267.003.061-.063.356-.085.417-.055.152-.17.255-.29.349-.315.246-.589.527-.755.896a2.303 2.303 0 00-.172.599c-.045.291-.019.579-.036.867-.005.081-.033.16-.04.241a3.89 3.89 0 01-.035.264c-.013.081-.053.155-.054.239-.002.088-.048.165-.082.245-.031.073-.042.155-.069.23a2.393 2.393 0 01-.578.925c-.057.055-.112.112-.168.167-.265.265-.564.422-.96.595-.248.108-.511.152-.76.246-.091.034-.203.029-.304.042-.158.02-.314.082-.477.05-.235.077-.476.036-.715.042-.244.006-.489.005-.733-.001-.095-.002-.189-.027-.284-.041-.095-.014-.187.005-.288-.034-.088-.034-.2-.033-.302-.05a3.769 3.769 0 01-.992-.313 2.925 2.925 0 01-1.002-.798 2.5 2.5 0 01-.474-.901c-.047-.16-.108-.315-.147-.479-.023-.097-.033-.198-.063-.295-.04-.13-.037-.273-.049-.411-.007-.082-.059-.152-.047-.241.01-.073.024-.155-.039-.22-.007-.007-.001-.028-.001-.042-.003-.085.021-.185-.015-.252-.05-.09-.007-.179-.04-.264-.029-.074-.063-.15-.074-.227a.826.826 0 00-.278-.51.693.693 0 00-.4-.172 1.496 1.496 0 00-.501.029.658.658 0 00-.501.446 2.806 2.806 0 00-.141.612c-.013.116-.013.238-.042.348-.031.118-.002.246-.044.347-.055.132-.011.269-.071.402-.052.114-.019.262-.054.387-.128.463-.268.923-.555 1.322a2.93 2.93 0 01-1.264 1 3.475 3.475 0 01-.83.236c-.211.032-.424.054-.632.091-.248.044-.493.024-.738.032a14.58 14.58 0 01-.754 0c-.088-.002-.175-.031-.263-.04-.089-.009-.174-.006-.265-.037-.1-.034-.216-.02-.326-.043-.132-.027-.263-.062-.394-.094a3.71 3.71 0 01-.871-.344 2.072 2.072 0 01-.518-.362c-.08-.082-.162-.163-.244-.244-.249-.249-.375-.488-.542-.875-.106-.245-.159-.497-.216-.752-.022-.105-.007-.215-.042-.306-.043-.112-.032-.22-.036-.33-.004-.107.004-.215-.002-.323-.01-.173-.005-.353-.047-.519-.07-.277-.149-.555-.331-.789a3.152 3.152 0 00-.559-.566c-.146-.112-.296-.239-.345-.439zm8.915 1.818c-.02-.191.028-.431-.038-.67-.027-.097-.048-.193-.09-.287-.123-.277-.275-.524-.533-.705a3.024 3.024 0 00-.568-.299c-.147-.062-.307-.092-.462-.133-.159-.041-.328-.019-.482-.084-.226.024-.447-.037-.672-.042-.28-.006-.56-.001-.84-.001-.136 0-.274-.008-.409.002-.138.01-.273-.018-.416.032-.122.042-.271.009-.407.009-.014 0-.033-.006-.042.001-.095.07-.209.016-.305.046-.103.033-.209.049-.31.083-.164.055-.343.09-.483.183-.148.099-.305.194-.416.352-.148.213-.254.431-.253.694 0 .611.006 1.221-.004 1.832-.003.191.091.358.095.543.136.24.24.501.441.701.163.161.343.293.538.417.283.179.592.276.907.362.163.045.326.111.502.089.068.083.161.027.241.043.08.016.161.044.241.041.389-.016.778.035 1.169-.034.194-.034.392-.057.589-.089a2.36 2.36 0 00.629-.202 1.95 1.95 0 00.723-.589c.143-.197.289-.386.371-.623.05-.143.116-.284.151-.432.034-.143.084-.283.095-.436.01-.159.049-.316.039-.478-.006-.093-.001-.186-.001-.326zm10.779.1v-.97a.994.994 0 00-.098-.391 1.248 1.248 0 00-.424-.509 1.772 1.772 0 00-.33-.191c-.097-.043-.206-.058-.308-.09-.102-.032-.208-.055-.311-.079-.105-.024-.217-.029-.326-.044-.179-.025-.361-.024-.542-.041-.306-.029-.617-.016-.926-.006-.303.01-.606-.032-.91.034-.174.038-.36.02-.542.042a5.491 5.491 0 00-.677.14c-.221.056-.644.292-.792.428-.314.288-.479.657-.536 1.069-.028.204-.012.416-.003.624.009.203-.016.403.032.609.035.15.054.306.09.459.056.243.13.48.253.693.167.29.345.57.631.773.278.198.672.388.987.433.102.015.215.015.302.05.101.04.194.016.288.034.094.018.184.051.284.044.367-.025.735.028 1.104-.038.187-.034.378-.057.567-.089.313-.054.607-.163.894-.288.14-.061.267-.153.399-.233.245-.147.444-.353.585-.589.186-.312.313-.657.31-1.034-.003-.279-.001-.56-.001-.84z"
});

function SvgImpersonate(props) {
  return React.createElement("svg", _extends$P({
    viewBox: "0 0 24 24"
  }, props), _ref$P);
}

function _extends$Q() { _extends$Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

var _ref$Q =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 1.5C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12 17.799 1.5 12 1.5zM13.295 19h-2.59V9.326h2.59V19zm.178-11.814a1.663 1.663 0 01-.868.835 1.63 1.63 0 01-1.238 0 1.57 1.57 0 01-.502-.338 1.645 1.645 0 01-.342-.497 1.459 1.459 0 01-.127-.61c0-.219.042-.424.127-.615.085-.191.199-.358.342-.502A1.57 1.57 0 0111.972 5c.225 0 .436.041.633.122.197.081.369.194.516.338.147.144.265.311.352.502.087.191.132.396.132.615 0 .219-.045.422-.132.609z"
});

function SvgInformation(props) {
  return React.createElement("svg", _extends$Q({
    viewBox: "0 0 24 24"
  }, props), _ref$Q);
}

function _extends$R() { _extends$R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

var _ref$R =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.73 1.72l1.45-.386.734 2.763-1.45.385zM18.002 4.28l2.005-2.024 1.065 1.056-2.004 2.023zM19.065 7.84l.391-1.448 2.739.74-.391 1.449zM9.871 2.426l.494.497-7.779 14.399-.054-.054-1.064 1.058 3.706 3.729 1.064-1.058-.036-.036 2.092-1.15.584.59a2.794 2.794 0 001.998.834c.755 0 1.465-.296 1.998-.834.903-.911 1.05-2.287.466-3.363l7.147-3.928.485.488 1.064-1.058-11.1-11.171-1.065 1.057zm1.938 16.919c-.498.503-1.365.504-1.865 0l-.283-.285 2.357-1.296c.274.509.217 1.151-.209 1.581zm7.565-7.336L5.102 19.854l-1.41-1.422 7.777-14.396 7.905 7.973z"
});

function SvgInstantMessages(props) {
  return React.createElement("svg", _extends$R({
    viewBox: "0 0 24 24"
  }, props), _ref$R);
}

function _extends$S() { _extends$S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

var _ref$S =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.953 20.089L8.001 11.936l12.952-8.025-.776-2.284-17.13 10.309 17.13 10.437z"
});

function SvgLeftCaret(props) {
  return React.createElement("svg", _extends$S({
    viewBox: "0 0 24 24"
  }, props), _ref$S);
}

function _extends$T() { _extends$T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }

var _ref$T =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.763 19.674v-2.239c0-.187-.047-.356-.141-.508s-.256-.286-.49-.402l-7.857-3.973a6.986 6.986 0 00-.727-.315 5.3 5.3 0 00-.812-.227 8.58 8.58 0 00.812-.236c.252-.088.494-.195.727-.324l7.857-3.99c.234-.116.396-.248.49-.394s.141-.318.141-.517V4.326L5.237 11.344v1.295l13.526 7.035z"
});

function SvgLessThan(props) {
  return React.createElement("svg", _extends$T({
    viewBox: "0 0 24 24"
  }, props), _ref$T);
}

function _extends$U() { _extends$U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }

var _ref$U =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.097 5.621h1.078v-3.42c0-.103.003-.207.01-.312l-.896.767a.217.217 0 01-.136.052.201.201 0 01-.095-.022.17.17 0 01-.063-.054l-.196-.27L4.29 1.07h.507v4.55h.987v.476H3.097v-.475zM4.196 9.425c.212 0 .411.031.595.094s.343.155.478.275.24.267.317.439c.077.173.115.369.115.588 0 .187-.028.359-.084.518-.056.159-.132.311-.228.457s-.206.287-.331.423a14.9 14.9 0 01-.397.418l-1.319 1.351c.093-.026.188-.046.284-.062.095-.015.188-.022.276-.022h1.68c.068 0 .122.02.161.059.04.04.06.091.06.154v.378H2.456v-.213a.365.365 0 01.112-.266l1.606-1.613c.133-.136.254-.266.364-.391.11-.125.204-.25.282-.376.079-.126.139-.254.181-.383s.063-.268.063-.415-.023-.276-.07-.387c-.046-.111-.111-.202-.192-.274s-.177-.126-.287-.163a1.161 1.161 0 00-.704.002.937.937 0 00-.616.693.28.28 0 01-.084.147.228.228 0 01-.147.045l-.037-.001-.044-.005-.326-.056c.033-.229.096-.431.189-.607a1.452 1.452 0 01.85-.714c.185-.062.385-.093.6-.093zM4.262 17.825c.212 0 .408.03.588.091s.334.147.464.259a1.195 1.195 0 01.411.934c0 .159-.021.301-.061.425a1.037 1.037 0 01-.45.569 1.503 1.503 0 01-.36.157c.327.086.572.231.736.434.165.203.247.458.247.763 0 .231-.044.438-.131.623a1.4 1.4 0 01-.359.471 1.589 1.589 0 01-.53.297 1.993 1.993 0 01-.649.104c-.266 0-.494-.033-.683-.1a1.408 1.408 0 01-.479-.274 1.46 1.46 0 01-.322-.415 3.074 3.074 0 01-.213-.52l.266-.112a.365.365 0 01.146-.031c.047 0 .088.01.124.03s.064.051.083.093l.014.03.014.033c.033.068.072.144.119.229a1.003 1.003 0 00.924.505c.175 0 .329-.028.46-.085a.949.949 0 00.527-.527.906.906 0 00.066-.333c0-.135-.018-.259-.054-.371s-.102-.209-.196-.291a.99.99 0 00-.392-.192 2.43 2.43 0 00-.643-.07v-.455c.212 0 .394-.022.544-.067.15-.044.273-.105.369-.182a.667.667 0 00.208-.277.95.95 0 00.064-.357.952.952 0 00-.068-.378.727.727 0 00-.469-.423 1.139 1.139 0 00-.702.003.912.912 0 00-.494.393 1.115 1.115 0 00-.126.299.281.281 0 01-.084.146.223.223 0 01-.144.045l-.037-.001-.044-.005-.325-.055c.032-.229.095-.431.189-.607a1.438 1.438 0 01.849-.714c.189-.06.389-.091.603-.091z"
});

var _ref2$m =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M7.467 4h14.688M7.467 12h14.688M7.467 20h14.688"
});

function SvgList(props) {
  return React.createElement("svg", _extends$U({
    viewBox: "0 0 24 24"
  }, props), _ref$U, _ref2$m);
}

function _extends$V() { _extends$V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }

var _ref$V =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeMiterlimit: 10,
  d: "M4.399 17.236c.164 1.877.564 2.146 1.636 3.161.125.118.913.655 1.913.653.593-.001 1.62-.032 1.559-.732l-.384-4.388c-.097-1.104-.214-2.001-.277-2.722-.045-.514-.071-.433-1.688-.291 0 0-.696.17-.964.37-.951.708-1.962 2.038-1.795 3.949zM19.973 17.236c-.164 1.877-.564 2.146-1.636 3.161-.125.118-.913.655-1.913.653-.593-.001-1.62-.032-1.559-.732l.384-4.388c.097-1.104.214-2.001.277-2.722.045-.514.071-.433 1.688-.291 0 0 .696.17.964.37.951.708 1.962 2.038 1.795 3.949z"
});

var _ref2$n =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  d: "M20.109 15.827c.614-1.023.995-3.812.927-5.081-.286-5.406-5.791-7.796-9.275-7.796-3.516 0-8.422 2.548-8.797 7.86-.089 1.257.65 4.006 1.199 5.055"
});

function SvgListen(props) {
  return React.createElement("svg", _extends$V({
    viewBox: "0 0 24 24"
  }, props), _ref$V, _ref2$n);
}

function _extends$W() { _extends$W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }

var _ref$W =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.25 2h1.5v9.225h-1.5z"
});

var _ref2$o =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 22.75C6.072 22.75 1.25 17.927 1.25 12c0-3.7 1.875-7.095 5.016-9.082l.802 1.268A9.206 9.206 0 002.75 12c0 5.101 4.149 9.25 9.25 9.25s9.25-4.15 9.25-9.25a9.207 9.207 0 00-4.317-7.814l.802-1.268A10.7 10.7 0 0122.75 12c0 5.927-4.822 10.75-10.75 10.75z"
});

function SvgLogout(props) {
  return React.createElement("svg", _extends$W({
    viewBox: "0 0 24 24"
  }, props), _ref$W, _ref2$o);
}

function _extends$X() { _extends$X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }

var _ref$X =
/*#__PURE__*/
React.createElement("path", {
  d: "M22 5H2a1 1 0 110-2h20a1 1 0 110 2zM22 13H2a1 1 0 110-2h20a1 1 0 110 2zM22 21H2a1 1 0 110-2h20a1 1 0 110 2z"
});

function SvgMenu(props) {
  return React.createElement("svg", _extends$X({
    viewBox: "0 0 24 24"
  }, props), _ref$X);
}

function _extends$Y() { _extends$Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }

var _ref$Y =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.631 20.784c-.218-.34-.81-1.449-.829-2.285.144-.305.271-.627.377-.96.895-2.794.182-5.817-1.861-7.889a7.592 7.592 0 00-3.654-2.062 7.745 7.745 0 00-2.128-4.21 7.568 7.568 0 00-5.427-2.279c-2.05 0-3.978.809-5.427 2.278a7.804 7.804 0 00-1.861 7.888c.107.336.234.659.377.962-.018.831-.595 1.918-.83 2.285a.75.75 0 00.514 1.145c.274.044 2.595.4 4.007.253.47.221.955.383 1.446.502a7.743 7.743 0 002.128 4.214 7.605 7.605 0 005.421 2.278 7.593 7.593 0 003.227-.721c1.412.145 3.731-.209 4.006-.253a.752.752 0 00.514-1.146zM7.239 14.832a6.17 6.17 0 01-.885-.363.746.746 0 00-.46-.071c-.649.105-1.815.021-2.728-.083.289-.645.574-1.504.525-2.313a.729.729 0 00-.077-.293 6.08 6.08 0 01-.364-.9c-.725-2.261-.15-4.705 1.5-6.378a6.08 6.08 0 014.359-1.832 6.08 6.08 0 014.359 1.832 6.229 6.229 0 011.612 2.95c-.063-.002-.126-.009-.19-.009a7.57 7.57 0 00-5.428 2.279 7.78 7.78 0 00-2.223 5.181zm3.293-4.128a6.08 6.08 0 014.359-1.832c.129 0 .256.011.384.019a6.294 6.294 0 01-1.806 4.409 6.086 6.086 0 01-4.742 1.8 6.29 6.29 0 011.805-4.396zm10.301 9.883c-.912.103-2.078.189-2.728.083a.779.779 0 00-.46.071 6.091 6.091 0 01-7.114-1.169c-.831-.842-1.354-1.871-1.613-2.952.066.002.131.011.197.011a7.606 7.606 0 005.421-2.279 7.774 7.774 0 002.224-5.186c.928.299 1.78.818 2.489 1.537a6.31 6.31 0 011.501 6.379c-.101.317-.224.62-.365.9a.76.76 0 00-.078.292c-.047.809.238 1.669.526 2.313z"
});

function SvgMessages(props) {
  return React.createElement("svg", _extends$Y({
    viewBox: "0 0 24 24"
  }, props), _ref$Y);
}

function _extends$Z() { _extends$Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }

var _ref$Z =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  d: "M5.52 12H22M10.689 6.831L5.52 12l5.169 5.169"
});

var _ref2$p =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  d: "M22 5.82V2H2v20h20v-3.82"
});

function SvgMinimize(props) {
  return React.createElement("svg", _extends$Z({
    viewBox: "0 0 24 24"
  }, props), _ref$Z, _ref2$p);
}

function _extends$_() { _extends$_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }

var _ref$_ =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.972 21l6.355-6.277-.848-.723-5.47 5.403-2.347-2.527-.88.689zM9.321 3.625v5.75h-5.75v-5.75h5.75m1.5-1.5h-8.75v8.75h8.75v-8.75zM9.321 14.625v5.75h-5.75v-5.75h5.75m1.5-1.5h-8.75v8.75h8.75v-8.75zM15.972 10l6.355-6.277L21.479 3l-5.47 5.403-2.347-2.527-.88.689z"
});

function SvgMultiselect(props) {
  return React.createElement("svg", _extends$_({
    viewBox: "0 0 24 24"
  }, props), _ref$_);
}

function _extends$$() { _extends$$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }

var _ref$$ =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.619 7.111l-3.74 2.503v4.623l3.74 2.379z"
});

var _ref2$q =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm1.082 18.281L6.934 15.37H3V8.492h3.925l6.158-4.121v14.91zm6.15-3.722l-1.729-2.324-1.694 2.318-1.211-.885 1.968-2.693-1.964-2.639 1.203-.896 1.687 2.267 1.653-2.262 1.211.885-1.927 2.637 2.006 2.696-1.203.896z"
});

var _ref3$4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.464 9.955h1.951v3.952H4.464z"
});

function SvgMute(props) {
  return React.createElement("svg", _extends$$({
    viewBox: "0 0 24 24"
  }, props), _ref$$, _ref2$q, _ref3$4);
}

function _extends$10() { _extends$10 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }

var _ref$10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.25 3.25v17.5h11.873v-1.5H3.652l6.671-7.631L12 12.96l9.25-7.4v6.147h1.5V3.25H1.25zm1.5 14.753V5.56l6.401 5.121-6.401 7.322zM4.138 4.75h15.724L12 11.04 4.138 4.75z"
});

var _ref2$r =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.546 13.064h-1.5v2.687h-2.4v1.5h2.4v2.685h1.5v-2.685h2.4v-1.5h-2.4z"
});

function SvgNewEmail(props) {
  return React.createElement("svg", _extends$10({
    viewBox: "0 0 24 24"
  }, props), _ref$10, _ref2$r);
}

function _extends$11() { _extends$11 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }

var _ref$11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1z"
});

var _ref2$s =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M8.139 5.542h2v12.917h-2zM13.861 5.542h2v12.917h-2z"
});

function SvgPause(props) {
  return React.createElement("svg", _extends$11({
    viewBox: "0 0 24 24"
  }, props), _ref$11, _ref2$s);
}

function _extends$12() { _extends$12 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }

var _ref$12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.69 17.306c-.219-.835-1.024-1.61-2.443-2.33-2.685-1.36-4.164-2.111-5.481-.083-.481.739-.933 1.357-1.592 1.426-.568.06-1.618-.251-3.431-2.063-1.813-1.812-2.123-2.865-2.063-3.43.069-.66.687-1.111 1.426-1.592 2.028-1.318 1.278-2.798-.108-5.531-.694-1.368-1.469-2.174-2.304-2.393a1.604 1.604 0 00-1.166.111A7.648 7.648 0 001.25 8.458c0 4.968 4.486 9.437 4.668 9.615.188.191 4.656 4.677 9.624 4.677a7.649 7.649 0 007.038-4.278 1.61 1.61 0 00.11-1.166zM6.214 2.753a.121.121 0 01.03-.004c.164 0 .716.251 1.44 1.679 1.455 2.869 1.415 3.023.605 3.549a16.18 16.18 0 00-.384.257L5.209 3.372c.522-.395.94-.589 1.005-.619zm.765 14.26c-.042-.042-4.229-4.221-4.229-8.555 0-1.806.625-3.106 1.344-4.004L6.765 9.27a2.747 2.747 0 00-.577 1.399c-.138 1.312.678 2.832 2.494 4.648 1.816 1.816 3.338 2.629 4.647 2.494a2.738 2.738 0 001.348-.534l4.59 2.836c-.881.625-2.094 1.137-3.726 1.137-4.333 0-8.512-4.186-8.562-4.237zm14.241.825c-.024.055-.27.591-.804 1.222l-4.695-2.901c.112-.159.215-.313.302-.448.525-.809.677-.851 3.595.628 1.486.753 1.663 1.332 1.665 1.38l-.063.119z"
});

function SvgPhoneCall(props) {
  return React.createElement("svg", _extends$12({
    viewBox: "0 0 24 24"
  }, props), _ref$12);
}

function _extends$13() { _extends$13 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }

var _ref$13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.091 2A9.09 9.09 0 002 11.091h9.091V2zM9.758 9.758h-6.31a7.78 7.78 0 016.31-6.31v6.31z"
});

var _ref2$t =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.909 3.818v9.091H3.818c0 5.021 4.07 9.091 9.091 9.091S22 17.93 22 12.909s-4.07-9.091-9.091-9.091zm0 16.849c-3.823 0-7.009-2.78-7.643-6.424H14.242V5.266c3.644.634 6.424 3.82 6.424 7.643.001 4.278-3.479 7.758-7.757 7.758z"
});

function SvgPieChart(props) {
  return React.createElement("svg", _extends$13({
    viewBox: "0 0 24 24"
  }, props), _ref$13, _ref2$t);
}

function _extends$14() { _extends$14 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }

var _ref$14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1z"
});

var _ref2$u =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M18.827 12L8.051 5.778v12.444z"
});

function SvgPlay(props) {
  return React.createElement("svg", _extends$14({
    viewBox: "0 0 24 24"
  }, props), _ref$14, _ref2$u);
}

function _extends$15() { _extends$15 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }

var _ref$15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.003 1.329H3.25V22.67h17.5V7.937l-6.747-6.608zm.232 2.327l3.836 3.757h-3.836V3.656zM4.75 21.171V2.829h7.985v6.083h6.515V21.17H4.75z"
});

var _ref2$v =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.3 18.039l-2.858-2.844c.28-.467.451-1.006.451-1.589 0-1.712-1.389-3.105-3.096-3.105a3.104 3.104 0 00-.001 6.208c.582 0 1.121-.172 1.586-.453l2.854 2.839 1.064-1.056zm-5.504-2.83c-.88 0-1.596-.72-1.596-1.604S9.916 12 10.796 12s1.596.72 1.596 1.605-.716 1.604-1.596 1.604z"
});

function SvgPrintPreview(props) {
  return React.createElement("svg", _extends$15({
    viewBox: "0 0 24 24"
  }, props), _ref$15, _ref2$v);
}

function _extends$16() { _extends$16 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }

var _ref$16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.75 7.754H19.5v-1.6h-1.75V4.25H6.25v1.904H4.5v1.6H1.25v10.5h5v1.496h11.5v-1.496h5v-10.5zm-4.75-.1v.1h-.25v-.1H18zM7.75 5.75h8.5v2.003h-8.5V5.75zM6 7.654h.25v.1H6v-.1zM16.25 18.25h-8.5v-4.5h8.5v4.5zm5-1.496h-3.5V13.75h1v-1.5H5.25v1.5h1v3.004h-3.5v-7.5h18.5v7.5z"
});

var _ref2$w =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.542 14.464h6.917v1.5H8.542zM8.542 16.187h4.991v1.5H8.542z"
});

function SvgPrint(props) {
  return React.createElement("svg", _extends$16({
    viewBox: "0 0 24 24"
  }, props), _ref$16, _ref2$w);
}

function _extends$17() { _extends$17 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }

var _ref$17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.251 15.087l-3.392-3.392a2.558 2.558 0 00-3.614 0l-.422.422-.94-.94.422-.422a2.557 2.557 0 000-3.614L8.913 3.749a2.558 2.558 0 00-3.614 0L3.749 5.3a2.557 2.557 0 000 3.614l3.392 3.392a2.55 2.55 0 001.807.747c.655 0 1.309-.249 1.807-.747l.422-.422.94.94-.422.422a2.557 2.557 0 000 3.614l3.392 3.392a2.547 2.547 0 001.807.747 2.55 2.55 0 001.808-.747l1.55-1.551a2.558 2.558 0 00-.001-3.614zm-10.204-3.489a1.558 1.558 0 01-2.2 0L4.456 8.206a1.558 1.558 0 010-2.2l1.55-1.551c.303-.303.702-.455 1.1-.455s.797.151 1.1.455l3.392 3.392a1.558 1.558 0 010 2.2l-.422.422-2.868-2.868-.707.707 2.869 2.869-.423.421zm9.497 6.396l-1.55 1.551a1.558 1.558 0 01-2.2 0l-3.392-3.392a1.558 1.558 0 010-2.2l.422-.422 2.869 2.869.707-.707-2.869-2.869.422-.422c.303-.303.702-.455 1.1-.455s.797.151 1.1.455l3.392 3.392a1.557 1.557 0 01-.001 2.2z"
});

function SvgQuickLinks(props) {
  return React.createElement("svg", _extends$17({
    viewBox: "0 0 24 24"
  }, props), _ref$17);
}

function _extends$18() { _extends$18 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }

var _ref$18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.806 5.026C10.5 3.72 8.763 3 6.916 3s-3.584.72-4.89 2.026C.719 6.332 0 8.068 0 9.916s.72 3.584 2.026 4.89 3.043 2.026 4.89 2.026 3.584-.72 4.89-2.026c1.306-1.306 2.026-3.043 2.026-4.89s-.719-3.584-2.026-4.89zm-.897 8.883c-1.067 1.067-2.485 1.655-3.993 1.655s-2.927-.587-3.993-1.655a5.61 5.61 0 01-1.654-3.993c0-1.508.587-2.927 1.655-3.993C3.99 4.856 5.408 4.269 6.916 4.269s2.927.587 3.993 1.655c1.067 1.067 1.655 2.485 1.655 3.993s-.588 2.925-1.655 3.992z"
});

var _ref2$x =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.582 12.833l-.898.897a3.136 3.136 0 002.231.925c.843 0 1.636-.328 2.231-.925l-.896-.897c-.713.713-1.955.713-2.668 0zM12.015 15.912l.897-.897L18 20.103l-.897.898zM24 4.769h-.958v-1H24v1zm-1.958 0h-1v-1h1v1zm-2 0h-1v-1h1v1zm-2 0h-1v-1h1v1zm-2 0h-1v-1h1v1zm-2 0h-1v-1h1v1zM22.008 7.185h-1v-1h1v1zm-2 0h-1v-1h1v1zm-2 0h-1v-1h1v1zm-2 0h-1v-1h1v1zM19.994 9.602h-.986v-1h.986v1zm-1.986 0h-1v-1h1v1zm-2 0h-1v-1h1v1zM18 12.018h-.992v-1H18v1zm-1.992 0h-1v-1h1v1z"
});

function SvgQuickSearch(props) {
  return React.createElement("svg", _extends$18({
    viewBox: "0 0 24 24"
  }, props), _ref$18, _ref2$x);
}

function _extends$19() { _extends$19 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }

var _ref$19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.181 15.683a10.187 10.187 0 01-1.924-.543 10.481 10.481 0 01-1.67-.84 12.68 12.68 0 01-1.508-1.058c-.465-.386-.891-.781-1.266-1.165s-.701-.808-.967-1.141c-.276-.313-.482-.666-.63-.857-.147-.212-.215-.343-.215-.343s.072-.139.224-.347c.152-.189.366-.536.65-.843.274-.317.609-.733.993-1.108.385-.385.819-.77 1.294-1.145.474-.364.988-.718 1.532-1.022a10.385 10.385 0 011.689-.79 10.132 10.132 0 013.688-.627c1.25.025 2.497.26 3.662.723s2.247 1.137 3.178 1.898c.466.376.891.771 1.266 1.165.375.384.701.808.977 1.132.266.303.482.656.62.847.148.212.226.353.226.353s-.082.129-.234.337c-.142.188-.366.536-.64.833-.284.327-.619.743-1.003 1.108-.385.385-.819.77-1.294 1.145-.949.729-2.047 1.386-3.222 1.812a9.906 9.906 0 01-1.926.507",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref2$y =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.221 12.273A3.006 3.006 0 019 9.819a2.995 2.995 0 013.035-2.964A3.003 3.003 0 0115 9.89a2.987 2.987 0 01-1.279 2.415M11.875 20.146l.122-10.295M9.987 18.168l1.889 1.934 1.933-1.889",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

function SvgQuickView(props) {
  return React.createElement("svg", _extends$19({
    viewBox: "0 0 24 24"
  }, props), _ref$19, _ref2$y);
}

function _extends$1a() { _extends$1a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }

var _ref$1a =
/*#__PURE__*/
React.createElement("path", {
  d: "M4 9.05h16V12H4z"
});

function SvgRange(props) {
  return React.createElement("svg", _extends$1a({
    viewBox: "0 0 24 24"
  }, props), _ref$1a);
}

function _extends$1b() { _extends$1b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }

var _ref$1b =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.188 17.814a5.322 5.322 0 01-1.637.25c-3.427 0-6.731-3.31-6.77-3.35-.034-.033-3.344-3.338-3.344-6.765 0-1.428.494-2.456 1.063-3.166l2.112 3.808c-.232.303-.41.665-.456 1.107-.109 1.037.536 2.239 1.972 3.675s2.64 2.079 3.675 1.972c.42-.044.771-.207 1.066-.422l2.321 1.434v-1.394l-1.495-.924c.088-.125.17-.247.239-.354.285-.439.448-.58 1.256-.256v-1.254c-.924-.272-1.612-.12-2.251.863-.38.585-.737 1.073-1.259 1.128-.449.047-1.279-.199-2.713-1.631-1.433-1.434-1.678-2.267-1.631-2.713.053-.522.541-.879 1.126-1.259 1.604-1.042 1.01-2.213-.085-4.373-.549-1.083-1.162-1.719-1.823-1.893a1.264 1.264 0 00-.921.088A6.048 6.048 0 001.25 7.949c0 3.928 3.547 7.461 3.691 7.603.148.151 3.682 3.698 7.609 3.698a6.65 6.65 0 001.637-.202v-1.234zM5.175 3.438a.078.078 0 01.024-.003c.13 0 .566.198 1.139 1.327 1.15 2.268 1.118 2.39.478 2.806-.092.06-.196.129-.303.203L4.38 3.928c.413-.313.744-.466.795-.49zM14.713 16.368v6.855h6.855v-1.275h-4.677l6.822-6.822-.902-.903-6.822 6.822-.001-4.677z"
});

function SvgReceivedCall(props) {
  return React.createElement("svg", _extends$1b({
    viewBox: "0 0 24 24"
  }, props), _ref$1b);
}

function _extends$1c() { _extends$1c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }

var _ref$1c =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.25 3.25v17.5h11.873v-1.5H3.652l6.671-7.631L12 12.96l1.652-1.332 1.494 1.356 1.075-.854-1.468-1.372L21.25 5.56v6.147h1.5V3.25H1.25zm1.5 14.753V5.56l6.401 5.121-6.401 7.322zM4.138 4.75h15.724L12 11.04 4.138 4.75z"
});

var _ref2$z =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.701 15.403v6.856h6.855v-1.276h-4.678l6.823-6.822-.903-.902-6.822 6.822v-4.678z"
});

function SvgReceivedEmail(props) {
  return React.createElement("svg", _extends$1c({
    viewBox: "0 0 24 24"
  }, props), _ref$1c, _ref2$z);
}

function _extends$1d() { _extends$1d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }

var _ref$1d =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.969 21.25H4.75v-3.465h9.219v-1.5H4.75V7.507h14.5V13h1.5V1.25H3.25v21.5h10.719v-1.5zM4.75 2.75h14.5v3.257H4.75V2.75z"
});

var _ref2$A =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.058 18.146c-.803 0-1.454.597-1.454 1.333s.651 1.333 1.454 1.333c.803 0 1.454-.597 1.454-1.333 0-.737-.651-1.333-1.454-1.333zM14.7 15.398l.001 6.856h6.854v-1.276h-4.677l6.822-6.822-.902-.902-6.822 6.822v-4.678z"
});

function SvgReceivedText(props) {
  return React.createElement("svg", _extends$1d({
    viewBox: "0 0 24 24"
  }, props), _ref$1d, _ref2$A);
}

function _extends$1e() { _extends$1e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }

var _ref$1e =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.122 14.47L5.183 9.53l4.939-4.939"
});

var _ref2$B =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.065 9.53l3.048-3.049v-1.89L2.174 9.53l4.939 4.94v-1.891zM21.826 19.409h-2.964c0-4.63-3.767-8.397-8.397-8.397H7.483V8.049h2.982c6.265 0 11.361 5.096 11.361 11.36z"
});

function SvgReplyAll(props) {
  return React.createElement("svg", _extends$1e({
    viewBox: "0 0 24 24"
  }, props), _ref$1e, _ref2$B);
}

function _extends$1f() { _extends$1f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }

var _ref$1f =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.542 14.47L3.603 9.53l4.939-4.939"
});

var _ref2$C =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.397 19.409h-2.964c0-4.63-3.767-8.397-8.397-8.397H6.054V8.049h2.982c6.265 0 11.361 5.096 11.361 11.36z"
});

function SvgReply(props) {
  return React.createElement("svg", _extends$1f({
    viewBox: "0 0 24 24"
  }, props), _ref$1f, _ref2$C);
}

function _extends$1g() { _extends$1g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }

var _ref$1g =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.81 10h-1.526c.139.645.216 1.314.216 2 0 5.238-4.262 9.5-9.5 9.5S2.5 17.238 2.5 12 6.762 2.5 12 2.5c1.224 0 2.382.256 3.457.68l-.938 1.162 4.692.737L17.503.647l-1.057 1.308A10.945 10.945 0 0012 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11c0-.684-.071-1.351-.19-2z"
});

var _ref2$D =
/*#__PURE__*/
React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 2.5
});

function SvgRestore(props) {
  return React.createElement("svg", _extends$1g({
    viewBox: "0 0 24 24"
  }, props), _ref$1g, _ref2$D);
}

function _extends$1h() { _extends$1h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }

var _ref$1h =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.047 20.089l12.952-8.153L3.047 3.911l.776-2.284 17.13 10.309-17.13 10.437z"
});

function SvgRightCaret(props) {
  return React.createElement("svg", _extends$1h({
    viewBox: "0 0 24 24"
  }, props), _ref$1h);
}

function _extends$1i() { _extends$1i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }

var _ref$1i =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.477 1.25H4A2.753 2.753 0 001.25 4v16A2.752 2.752 0 004 22.75h16A2.752 2.752 0 0022.75 20V5.523L18.477 1.25zm-1.448 3.459l-5.69.034V2.75h5.666l.024 1.959zM5.301 12l13.363-.034v9.284H5.335L5.301 12zm15.949 8c0 .631-.477 1.133-1.086 1.217v-9.251c0-.808-.658-1.466-1.466-1.466H5.301c-.808 0-1.465.658-1.465 1.466v9.251C3.228 21.133 2.75 20.631 2.75 20V4c0-.689.561-1.25 1.25-1.25h5.838v1.993c0 .808.658 1.466 1.466 1.466h5.725c.808 0 1.466-.658 1.466-1.466V3.389l2.755 2.755V20z"
});

var _ref2$E =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.833 13.667h8.333v1.5H7.833zM7.833 15.667h8.333v1.5H7.833zM7.833 17.667h8.333v1.5H7.833z"
});

function SvgSave(props) {
  return React.createElement("svg", _extends$1i({
    viewBox: "0 0 24 24"
  }, props), _ref$1i, _ref2$E);
}

function _extends$1j() { _extends$1j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }

var _ref$1j =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.207 3.645C13.663 2.101 11.61 1.25 9.426 1.25s-4.237.851-5.781 2.395C2.1 5.189 1.25 7.242 1.25 9.426s.851 4.237 2.395 5.781c1.544 1.544 3.597 2.395 5.781 2.395s4.237-.851 5.781-2.395c1.544-1.544 2.395-3.597 2.395-5.781s-.85-4.237-2.395-5.781zm-1.06 10.502c-1.261 1.261-2.938 1.956-4.721 1.956s-3.46-.694-4.721-1.956C3.444 12.886 2.75 11.209 2.75 9.426s.694-3.46 1.956-4.721c1.26-1.261 2.937-1.955 4.72-1.955s3.46.694 4.721 1.956c1.261 1.261 1.956 2.938 1.956 4.721s-.695 3.459-1.956 4.72z"
});

var _ref2$F =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.849 12.875l-1.061 1.061a3.707 3.707 0 002.638 1.093c.997 0 1.934-.388 2.638-1.093l-1.061-1.061c-.843.843-2.311.843-3.154 0zM15.454 16.515l1.06-1.06 6.016 6.015-1.06 1.06z"
});

function SvgSearch(props) {
  return React.createElement("svg", _extends$1j({
    viewBox: "0 0 24 24"
  }, props), _ref$1j, _ref2$F);
}

function _extends$1k() { _extends$1k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }

var _ref$1k =
/*#__PURE__*/
React.createElement("path", {
  d: "M1 11.25h22v1.5H1z"
});

function SvgSectionCollapse(props) {
  return React.createElement("svg", _extends$1k({
    viewBox: "0 0 24 24"
  }, props), _ref$1k);
}

function _extends$1l() { _extends$1l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }

var _ref$1l =
/*#__PURE__*/
React.createElement("path", {
  d: "M23 11.25H12.75V1h-1.5v10.25H1v1.5h10.25V23h1.5V12.75H23z"
});

function SvgSectionExpand(props) {
  return React.createElement("svg", _extends$1l({
    viewBox: "0 0 24 24"
  }, props), _ref$1l);
}

function _extends$1m() { _extends$1m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }

var _ref$1m =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.583 9.847V7.603C18.583 4.1 15.63 1.25 12 1.25S5.416 4.1 5.416 7.603v2.244H1.25V22.75h21.5V9.847h-4.167zM6.916 7.603c0-2.676 2.28-4.853 5.083-4.853s5.083 2.177 5.083 4.853v2.244H6.916V7.603zM21.25 21.25H2.75v-9.903h18.5v9.903z"
});

var _ref2$G =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.25 16.698v2.101h1.5v-2.101a1.905 1.905 0 001.152-1.747c0-1.049-.854-1.902-1.902-1.902s-1.902.854-1.902 1.902c0 .782.475 1.455 1.152 1.747zm.75-2.15c.222 0 .402.181.402.402h-.805a.404.404 0 01.403-.402z"
});

function SvgSecurity(props) {
  return React.createElement("svg", _extends$1m({
    viewBox: "0 0 24 24"
  }, props), _ref$1m, _ref2$G);
}

function _extends$1n() { _extends$1n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }

var _ref$1n =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.063 20.299a2.156 2.156 0 01-2.156 2.156H4.094a2.156 2.156 0 01-2.156-2.156V4.487c0-1.191.965-2.156 2.156-2.156h15.813c1.191 0 2.156.965 2.156 2.156v15.812zM13.08 5.206c-.958 0-1.441 1.162-.763 1.84l1.437 1.437-8.784 8.784a.54.54 0 000 .762l1.394 1.394c.21.21.552.21.762 0l8.784-8.784 1.437 1.437c.675.675 1.84.201 1.84-.762v-5.03c0-.595-.483-1.078-1.078-1.078H13.08z"
});

function SvgSeeMore(props) {
  return React.createElement("svg", _extends$1n({
    viewBox: "0 0 24 24"
  }, props), _ref$1n);
}

function _extends$1o() { _extends$1o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }

var _ref$1o =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.042 21.326l-2.35-8.776 8.952 4.094-3.674.588 3.972 3.997-1.044.961-4.42-4.008zM13.107 21.75h-2.214v-1.5h2.214v1.5zm-4.428 0H6.465v-1.5h2.214v1.5zM4.25 21.75h-2v-2h1.5v.5h.5zM3.75 17.536h-1.5v-2.214h1.5v2.214zm0-4.429h-1.5v-2.214h1.5v2.214zm0-4.428h-1.5V6.464h1.5v2.215zM3.75 4.25h-1.5v-2h2v1.5h-.5zM17.535 3.75h-2.214v-1.5h2.214v1.5zm-4.428 0h-2.214v-1.5h2.214v1.5zm-4.429 0H6.464v-1.5h2.214v1.5zM21.75 4.25h-1.5v-.5h-.5v-1.5h2zM21.75 13.107h-1.5v-2.214h1.5v2.214zm0-4.428h-1.5V6.464h1.5v2.215zM6.5 6.24h11v1.5h-11zM6.5 9.245h11v1.5h-11zM6.5 12.25h3.629v1.5H6.5z"
});

function SvgSelectAll(props) {
  return React.createElement("svg", _extends$1o({
    viewBox: "0 0 24 24"
  }, props), _ref$1o);
}

function _extends$1p() { _extends$1p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }

var _ref$1p =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 3c4.963 0 9 4.037 9 9s-4.037 9-9 9-9-4.037-9-9 4.037-9 9-9m0-1.5C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12 17.799 1.5 12 1.5z"
});

var _ref2$H =
/*#__PURE__*/
React.createElement("path", {
  d: "M6 7.318l.026 3.202L6 16.682l11.725-4.269.275-.139v-.586L6 7.318zm.847 1.199l8.416 3.064H6.857l-.01-3.064zm.013 3.901h8.403l-8.416 3.064.017-1.999-.004-1.065z"
});

function SvgSendAll(props) {
  return React.createElement("svg", _extends$1p({
    viewBox: "0 0 24 24"
  }, props), _ref$1p, _ref2$H);
}

function _extends$1q() { _extends$1q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }

var _ref$1q =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.241 3.608l.047 5.74-.047 11.044 21.015-7.652.494-.25v-1.05L1.241 3.608zm1.518 2.15l15.085 5.492H2.777l-.018-5.492zm.023 6.992h15.062L2.759 18.242l.03-3.583-.007-1.909z"
});

function SvgSend(props) {
  return React.createElement("svg", _extends$1q({
    viewBox: "0 0 24 24"
  }, props), _ref$1q);
}

function _extends$1r() { _extends$1r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }

var _ref$1r =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.188 16.814a5.322 5.322 0 01-1.637.25c-3.427 0-6.731-3.31-6.77-3.35-.034-.033-3.344-3.338-3.344-6.765 0-1.428.494-2.456 1.063-3.166l2.112 3.808c-.232.303-.41.665-.456 1.107-.109 1.037.536 2.239 1.972 3.675s2.64 2.079 3.675 1.972c.42-.044.771-.207 1.066-.422l2.321 1.434v-1.394l-1.495-.924c.088-.125.17-.247.239-.354.285-.439.448-.58 1.256-.256v-1.254c-.924-.272-1.612-.12-2.251.863-.38.585-.737 1.073-1.259 1.128-.449.047-1.279-.199-2.713-1.631-1.433-1.434-1.678-2.267-1.631-2.713.053-.522.541-.879 1.126-1.259 1.604-1.042 1.01-2.213-.085-4.373-.549-1.083-1.162-1.719-1.823-1.893a1.264 1.264 0 00-.921.088A6.048 6.048 0 001.25 6.949c0 3.928 3.547 7.461 3.691 7.603.148.151 3.682 3.698 7.609 3.698a6.65 6.65 0 001.637-.202v-1.234zM5.175 2.438a.078.078 0 01.024-.003c.13 0 .566.198 1.139 1.327 1.15 2.268 1.118 2.39.478 2.806-.092.06-.196.129-.303.203L4.38 2.928c.413-.313.744-.466.795-.49zM23.425 20.353v-6.855H16.57v1.275h4.677l-6.822 6.822.902.902 6.822-6.822v4.678z"
});

function SvgSentCall(props) {
  return React.createElement("svg", _extends$1r({
    viewBox: "0 0 24 24"
  }, props), _ref$1r);
}

function _extends$1s() { _extends$1s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }

var _ref$1s =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.25 3.25v17.5h11.873v-1.5H3.652l6.671-7.631L12 12.96l1.652-1.332 1.494 1.356 1.075-.854-1.468-1.372L21.25 5.56v6.147h1.5V3.25H1.25zm1.5 14.753V5.56l6.401 5.121-6.401 7.322zM4.138 4.75h15.724L12 11.04 4.138 4.75z"
});

var _ref2$I =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.425 20.358v-6.855H16.57v1.276h4.677l-6.822 6.822.902.902 6.822-6.822.001 4.677z"
});

function SvgSentEmail(props) {
  return React.createElement("svg", _extends$1s({
    viewBox: "0 0 24 24"
  }, props), _ref$1s, _ref2$I);
}

function _extends$1t() { _extends$1t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }

var _ref$1t =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.969 21.25H4.75v-3.465h9.219v-1.5H4.75V7.507h14.5V13h1.5V1.25H3.25v21.5h10.719v-1.5zM4.75 2.75h14.5v3.257H4.75V2.75z"
});

var _ref2$J =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.058 18.146c-.803 0-1.454.597-1.454 1.333s.651 1.333 1.454 1.333c.803 0 1.454-.597 1.454-1.333 0-.737-.651-1.333-1.454-1.333zM23.425 20.353v-6.855H16.57v1.276h4.677l-6.822 6.822.902.902 6.822-6.822v4.677z"
});

function SvgSentText(props) {
  return React.createElement("svg", _extends$1t({
    viewBox: "0 0 24 24"
  }, props), _ref$1t, _ref2$J);
}

function _extends$1u() { _extends$1u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }

var _ref$1u =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.299 22.749a3.034 3.034 0 01-2.155-.892 3.052 3.052 0 010-4.312l9.097-9.098a5.808 5.808 0 011.545-5.491 5.86 5.86 0 015.618-1.513l1.263.332-3.879 3.878.585 1.973 1.973.585 3.879-3.878.332 1.264a5.862 5.862 0 01-1.513 5.617 5.807 5.807 0 01-5.492 1.545l-9.098 9.098a3.043 3.043 0 01-2.155.892zM16.554 2.767a4.322 4.322 0 00-3.76 5.667l.143.438-9.734 9.733a1.541 1.541 0 00-.454 1.095 1.55 1.55 0 002.644 1.096l9.733-9.734.438.143a4.326 4.326 0 004.418-1.052 4.344 4.344 0 001.25-2.707l-2.458 2.458-3.609-1.071-1.071-3.609 2.46-2.457z"
});

function SvgService(props) {
  return React.createElement("svg", _extends$1u({
    viewBox: "0 0 24 24"
  }, props), _ref$1u);
}

function _extends$1v() { _extends$1v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1v.apply(this, arguments); }

var _ref$1v =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.713 12c0-.329-.022-.653-.061-.972L22 9.646l-2.999-5.293-2.347 1.381A7.74 7.74 0 0015 4.758V2H9.001v2.758a7.691 7.691 0 00-1.654.976l-2.348-1.38L2 9.646l2.348 1.381c-.038.32-.061.644-.061.973s.022.653.061.972L2 14.354l2.999 5.293 2.347-1.381c.506.391 1.061.72 1.654.976V22h6v-2.758a7.65 7.65 0 001.654-.976l2.347 1.381L22 14.354l-2.348-1.381c.039-.319.061-.643.061-.973z",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref2$K =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.939 12c0-1.722 1.37-3.118 3.061-3.118s3.061 1.396 3.061 3.118S13.69 15.118 12 15.118 8.939 13.722 8.939 12z",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

function SvgSettings(props) {
  return React.createElement("svg", _extends$1v({
    viewBox: "0 0 24 24"
  }, props), _ref$1v, _ref2$K);
}

function _extends$1w() { _extends$1w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1w.apply(this, arguments); }

var _ref$1w =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.293 14.343l-4.407 4.407.001-16.052h-1.333l-.001 16.052-4.407-4.407-.942.943 6.016 6.016 6.016-6.016zM3.937 13.683l-2.173 5.434h.569a.244.244 0 00.159-.053.27.27 0 00.087-.121l.508-1.312h2.438l.508 1.312c.02.051.051.092.091.125a.245.245 0 00.159.049h.569L4.68 13.683h-.743zm-.645 3.416l.853-2.207c.028-.065.056-.142.082-.229.027-.087.052-.18.078-.279l.081.277c.027.086.054.162.082.228l.853 2.211H3.292v-.001zM2.394 5.383h3.007l-3.079 4.33a.598.598 0 00-.051.101.304.304 0 00-.021.114v.288h4.073v-.598h-3.11l3.079-4.319a.437.437 0 00.076-.242v-.273H2.394v.599z"
});

function SvgSortAZReverse(props) {
  return React.createElement("svg", _extends$1w({
    viewBox: "0 0 24 24"
  }, props), _ref$1w);
}

function _extends$1x() { _extends$1x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1x.apply(this, arguments); }

var _ref$1x =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.293 14.343l-4.407 4.407.001-16.052h-1.333l-.001 16.052-4.407-4.407-.942.943 6.016 6.016 6.016-6.016zM3.937 4.78l-2.173 5.434h.569a.244.244 0 00.159-.053.27.27 0 00.087-.121l.508-1.312h2.438l.508 1.312c.02.051.051.092.091.125a.245.245 0 00.159.049h.569L4.68 4.78h-.743zm-.645 3.416l.853-2.207c.028-.065.056-.142.082-.229.027-.087.052-.18.078-.279l.081.277c.027.086.054.162.082.228l.853 2.211H3.292v-.001zM2.394 14.479h3.007l-3.079 4.33a.607.607 0 00-.051.102.304.304 0 00-.021.114v.288h4.073v-.599h-3.11l3.079-4.319a.437.437 0 00.076-.242v-.273H2.394v.599z"
});

function SvgSortAZ(props) {
  return React.createElement("svg", _extends$1x({
    viewBox: "0 0 24 24"
  }, props), _ref$1x);
}

function _extends$1y() { _extends$1y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1y.apply(this, arguments); }

var _ref$1y =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1z"
});

var _ref2$L =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M6.5 6.5h11v11h-11z"
});

function SvgStop(props) {
  return React.createElement("svg", _extends$1y({
    viewBox: "0 0 24 24"
  }, props), _ref$1y, _ref2$L);
}

function _extends$1z() { _extends$1z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1z.apply(this, arguments); }

var _ref$1z =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.5 2h5v4.167h-5zM9.5 9.917h5v4.167h-5zM9.5 17.833h5V22h-5z"
});

function SvgSubMenu(props) {
  return React.createElement("svg", _extends$1z({
    viewBox: "0 0 24 24"
  }, props), _ref$1z);
}

function _extends$1A() { _extends$1A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1A.apply(this, arguments); }

var _ref$1A =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.053 3h13.405v2H2.053zM2.053 11h13.405v2H2.053zM2.053 19h13.405v2H2.053z"
});

var _ref2$M =
/*#__PURE__*/
React.createElement("circle", {
  cx: 20.447,
  cy: 4,
  r: 1.5
});

var _ref3$5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 20.447,
  cy: 12,
  r: 1.5
});

var _ref4$2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 20.447,
  cy: 20,
  r: 1.5
});

function SvgSummaryView(props) {
  return React.createElement("svg", _extends$1A({
    viewBox: "0 0 24 24"
  }, props), _ref$1A, _ref2$M, _ref3$5, _ref4$2);
}

function _extends$1B() { _extends$1B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1B.apply(this, arguments); }

var _ref$1B =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.913 20L2 11.741l1.5-1.584L8.977 16.7 20.561 4 22 5.654z"
});

function SvgToDo(props) {
  return React.createElement("svg", _extends$1B({
    viewBox: "0 0 24 24"
  }, props), _ref$1B);
}

function _extends$1C() { _extends$1C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1C.apply(this, arguments); }

var _ref$1C =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.5 14.276V21.5h-19v-19h7.224V1H1v22h22v-8.724z"
});

var _ref2$N =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 13.439l1.061 1.061L20.644 3.917V8.91h1.5V1.356h-7.126v1.5h4.566z"
});

function SvgUndock(props) {
  return React.createElement("svg", _extends$1C({
    viewBox: "0 0 24 24"
  }, props), _ref$1C, _ref2$N);
}

function _extends$1D() { _extends$1D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1D.apply(this, arguments); }

var _ref$1D =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.314 15.065a.646.646 0 00-.478-.198.706.706 0 00-.267.052.631.631 0 00-.214.146.719.719 0 00-.141.217.697.697 0 00.141.747.687.687 0 00.481.195.665.665 0 00.622-.409.68.68 0 00.053-.269.666.666 0 00-.053-.264.709.709 0 00-.144-.217z",
  stroke: "currentColor",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref2$O =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.972 7.194a2.812 2.812 0 00-.951-.505 3.646 3.646 0 00-1.188-.16 4.21 4.21 0 00-.902.11 4.166 4.166 0 00-.771.268 4.238 4.238 0 00-.656.382c-.2.143-.384.293-.551.451l.421.64c.072.121.18.181.324.178.063-.001.146-.042.245-.122.1-.079.229-.167.387-.264.158-.096.351-.186.579-.268.228-.082.502-.126.822-.133a2.1 2.1 0 01.658.086c.205.063.384.157.538.282a1.374 1.374 0 01.515 1.062 1.71 1.71 0 01-.175.836c-.123.238-.277.45-.463.638a4.688 4.688 0 01-.598.512 6.888 6.888 0 00-.586.472 2.235 2.235 0 00-.43.517.963.963 0 00-.115.634l.123 1.326 1.039-.021.128-1.219a.796.796 0 01.23-.48c.136-.144.297-.291.484-.439.186-.148.386-.305.599-.472.213-.167.408-.362.584-.584.177-.223.322-.483.437-.781.114-.298.167-.65.159-1.056-.008-.4-.091-.76-.246-1.079a2.457 2.457 0 00-.64-.811z"
});

function SvgUnknown(props) {
  return React.createElement("svg", _extends$1D({
    viewBox: "0 0 24 24"
  }, props), _ref$1D, _ref2$O);
}

function _extends$1E() { _extends$1E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1E.apply(this, arguments); }

var _ref$1E =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.25 10.543h9.974V1.25H1.25v9.293zm1.5-7.793h6.974v6.293H2.75V2.75zM12.776 1.25v9.293h9.975V1.25h-9.975zm8.474 7.793h-6.975V2.75h6.975v6.293zM1.25 22.75h9.974v-9.293H1.25v9.293zm1.5-7.793h6.974v6.293H2.75v-6.293zM12.776 22.75h9.975v-9.293h-9.975v9.293zm1.5-7.793h6.975v6.293h-6.975v-6.293z"
});

function SvgViewAll(props) {
  return React.createElement("svg", _extends$1E({
    viewBox: "0 0 24 24"
  }, props), _ref$1E);
}

function _extends$1F() { _extends$1F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1F.apply(this, arguments); }

var _ref$1F =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.276 8.47h-.684c-.277 0-.534.081-.755.215l-.808-3.426a1.7 1.7 0 00-1.619-1.281H6.856c-.74 0-1.443.54-1.634 1.254l-.944 3.529a1.456 1.456 0 00-.87-.291h-.684c-.813 0-1.474.661-1.474 1.474v.345c0 .813.661 1.474 1.474 1.474h.684c.024 0 .046-.006.07-.007l-.131.491a7.321 7.321 0 00-.213 1.615v2.433c0 .257 0 .786.226 1.135.008.074.015.181.015.311v.809c0 .812.661 1.473 1.473 1.473h1.761c.812 0 1.473-.661 1.473-1.473l-.027-.782h4.908v-1.5H8.054c-.812 0-1.473.661-1.473 1.473l.027.782-1.734.027v-.809c0-.257 0-.786-.226-1.135a2.971 2.971 0 01-.015-.311v-2.433c0-.333.075-.906.162-1.227l1.876-7.017c.015-.056.127-.142.185-.142h10.555c.049 0 .147.078.159.125l1.305 5.534.452-.106c.256.436.725.732 1.266.732h.684c.813 0 1.474-.661 1.474-1.474v-.343a1.477 1.477 0 00-1.475-1.474zM2.75 10.289v-.32l.631-.025.026.319-.657.026zm17.869 0v-.32l.631-.025.026.319-.657.026z"
});

var _ref2$P =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.611 11.474h4.923c.271 0 .704-.064.963-.143l1.969-.597a.524.524 0 00.351-.621L17 6.852a.666.666 0 00-.612-.478H7.772a.691.691 0 00-.627.474l-.948 3.322a.487.487 0 00.34.603l2.107.573c.261.07.697.128.967.128zM5.76 13.417a.434.434 0 00-.49.44v.752c0 .271.221.492.492.492H7.7a.494.494 0 00.492-.492v-.441a.56.56 0 00-.49-.544l-1.942-.207zM14.793 12.397v8h6.08v-8h-6.08zm.48 1.8c0-.442.359-.801.801-.801h.799s-.072-.6.96-.6c1.068 0 .96.6.96.6h.801a.8.8 0 01.799.799v.134h-5.12v-.132zm5.12 4.813h-5.12v-.32h5.12v.32zm0-.911h-5.12v-.32h5.12v.32zm0-.911h-5.12v-.32h5.12v.32zm0-.911h-5.12v-.32h5.12v.32z"
});

function SvgViewFeatures(props) {
  return React.createElement("svg", _extends$1F({
    viewBox: "0 0 24 24"
  }, props), _ref$1F, _ref2$P);
}

function _extends$1G() { _extends$1G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1G.apply(this, arguments); }

var _ref$1G =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm1.082 18.281L6.934 15.37H3V8.492h3.925l6.158-4.121v14.91zm3.042-3.731l-.92-1.138c.408-.333 1.467-1.426 1.467-2.481 0-.694-.899-1.68-1.466-2.138l.918-1.14c.206.165 2.011 1.663 2.011 3.278 0 1.974-1.928 3.552-2.01 3.619z"
});

var _ref2$Q =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.619 7.111l-3.74 2.503v4.623l3.74 2.379zM4.464 9.955h1.951v3.952H4.464z"
});

function SvgVolumeDown(props) {
  return React.createElement("svg", _extends$1G({
    viewBox: "0 0 24 24"
  }, props), _ref$1G, _ref2$Q);
}

function _extends$1H() { _extends$1H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1H.apply(this, arguments); }

var _ref$1H =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.619 7.111l-3.74 2.503v4.623l3.74 2.379zM4.464 9.955h1.951v3.952H4.464z"
});

var _ref2$R =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm1.082 18.281L6.934 15.37H3V8.492h3.925l6.158-4.121v14.91zm2.123-9.488l.918-1.14c.206.165 2.011 1.663 2.011 3.278 0 1.974-1.928 3.552-2.01 3.618l-.92-1.138c.408-.333 1.467-1.426 1.467-2.481-.001-.693-.9-1.679-1.466-2.137zm1.274 10.289l-.869-1.178c.04-.029 3.926-2.954 3.926-6.973 0-3.295-3.942-6.891-3.982-6.927l.981-1.086C16.718 4.082 21 7.992 21 11.931c0 4.767-4.336 8.015-4.521 8.151z"
});

function SvgVolumeUp(props) {
  return React.createElement("svg", _extends$1H({
    viewBox: "0 0 24 24"
  }, props), _ref$1H, _ref2$R);
}

function _extends$1I() { _extends$1I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1I.apply(this, arguments); }

var _ref$1I =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.008 11.291V2.859s-1.859 1.135-5.64 1.135c-6.156 0-8.387-1.232-10.32-1.22-.914.006-1.764.571-1.764 1.228v9.992S4.977 12.5 6.048 12.5c3.57 0 8.117.998 10.32.998 3.499.012 5.64-1.285 5.64-2.207zM1.992 2h1.5v20h-1.5z"
});

function SvgWarning(props) {
  return React.createElement("svg", _extends$1I({
    viewBox: "0 0 24 24"
  }, props), _ref$1I);
}

/// <references path="./svg.d.ts" />
var IconAddCircle = function (props) { return React.createElement(SvgAddCircle, null); };
var IconAddPhoto = function (props) { return React.createElement(SvgAddPhoto, null); };
var IconAddVideoMedia = function (props) { return React.createElement(SvgAddVideoMedia, null); };
var IconAdd = function (props) { return React.createElement(SvgAdd, null); };
var IconAddress = function (props) { return React.createElement(SvgAddress, null); };
var IconAsterisk = function (props) { return React.createElement(SvgAsterisk, null); };
var IconAttach = function (props) { return React.createElement(SvgAttach, null); };
var IconBack = function (props) { return React.createElement(SvgBack, null); };
var IconBadgeDown = function (props) { return React.createElement(SvgBadgeDown, null); };
var IconBadgeUp = function (props) { return React.createElement(SvgBadgeUp, null); };
var IconCalendarView = function (props) { return React.createElement(SvgCalendarView, null); };
var IconCalendar = function (props) { return React.createElement(SvgCalendar, null); };
var IconCheckboxChecked = function (props) { return React.createElement(SvgCheckboxChecked, null); };
var IconCheckboxUnchecked = function (props) { return React.createElement(SvgCheckboxUnchecked, null); };
var IconCircle = function (props) { return React.createElement(SvgCircle, null); };
var IconCloseAllTabs = function (props) { return React.createElement(SvgCloseAllTabs, null); };
var IconClose = function (props) { return React.createElement(SvgClose, null); };
var IconCollapseMinus = function (props) { return React.createElement(SvgCollapseMinus, null); };
var IconColumnSortDown = function (props) { return React.createElement(SvgColumnSortDown, null); };
var IconColumnSortUp = function (props) { return React.createElement(SvgColumnSortUp, null); };
var IconColumnHandle = function (props) { return React.createElement(SvgColumnHandle, null); };
var IconDefaultUserImage = function (props) { return React.createElement(SvgDefaultUserImage, null); };
var IconDelete = function (props) { return React.createElement(SvgDelete, null); };
var IconDeselectAll = function (props) { return React.createElement(SvgDeselectAll, null); };
var IconDetailView = function (props) { return React.createElement(SvgDetailView, null); };
var IconDock = function (props) { return React.createElement(SvgDock, null); };
var IconDollar = function (props) { return React.createElement(SvgDollar, null); };
var IconDone = function (props) { return React.createElement(SvgDone, null); };
var IconDropDownReverse = function (props) { return React.createElement(SvgDropDownReverse, null); };
var IconDropDown = function (props) { return React.createElement(SvgDropDown, null); };
var IconEdit = function (props) { return React.createElement(SvgEdit, null); };
var IconEmailReadRecipient = function (props) { return React.createElement(SvgEmailReadRecipient, null); };
var IconEmailRead = function (props) { return React.createElement(SvgEmailRead, null); };
var IconEmailUnread = function (props) { return React.createElement(SvgEmailUnread, null); };
var IconEmail = function (props) { return React.createElement(SvgEmail, null); };
var IconEquals = function (props) { return React.createElement(SvgEquals, null); };
var IconErase = function (props) { return React.createElement(SvgErase, null); };
var IconError = function (props) { return React.createElement(SvgError, null); };
var IconExpandPlus = function (props) { return React.createElement(SvgExpandPlus, null); };
var IconExpand = function (props) { return React.createElement(SvgExpand, null); };
var IconExport = function (props) { return React.createElement(SvgExport, null); };
var IconFilter = function (props) { return React.createElement(SvgFilter, null); };
var IconForward = function (props) { return React.createElement(SvgForward, null); };
var IconFullScreen = function (props) { return React.createElement(SvgFullScreen, null); };
var IconGraphView = function (props) { return React.createElement(SvgGraphView, null); };
var IconGreaterThan = function (props) { return React.createElement(SvgGreaterThan, null); };
var IconHalfScreen = function (props) { return React.createElement(SvgHalfScreen, null); };
var IconHelp = function (props) { return React.createElement(SvgHelp, null); };
var IconHistory = function (props) { return React.createElement(SvgHistory, null); };
var IconHome = function (props) { return React.createElement(SvgHome, null); };
var IconIdentification = function (props) { return React.createElement(SvgIdentification, null); };
var IconImpersonate = function (props) { return React.createElement(SvgImpersonate, null); };
var IconInformation = function (props) { return React.createElement(SvgInformation, null); };
var IconInstantMessages = function (props) { return React.createElement(SvgInstantMessages, null); };
var IconLeftCaret = function (props) { return React.createElement(SvgLeftCaret, null); };
var IconLessThan = function (props) { return React.createElement(SvgLessThan, null); };
var IconList = function (props) { return React.createElement(SvgList, null); };
var IconListen = function (props) { return React.createElement(SvgListen, null); };
var IconLogout = function (props) { return React.createElement(SvgLogout, null); };
var IconMenu = function (props) { return React.createElement(SvgMenu, null); };
var IconMessages = function (props) { return React.createElement(SvgMessages, null); };
var IconMinimize = function (props) { return React.createElement(SvgMinimize, null); };
var IconMultiselect = function (props) { return React.createElement(SvgMultiselect, null); };
var IconMute = function (props) { return React.createElement(SvgMute, null); };
var IconNewEmail = function (props) { return React.createElement(SvgNewEmail, null); };
var IconPause = function (props) { return React.createElement(SvgPause, null); };
var IconPhoneCall = function (props) { return React.createElement(SvgPhoneCall, null); };
var IconPieChart = function (props) { return React.createElement(SvgPieChart, null); };
var IconPlay = function (props) { return React.createElement(SvgPlay, null); };
var IconPrintPreview = function (props) { return React.createElement(SvgPrintPreview, null); };
var IconPrint = function (props) { return React.createElement(SvgPrint, null); };
var IconQuickLinks = function (props) { return React.createElement(SvgQuickLinks, null); };
var IconQuickSearch = function (props) { return React.createElement(SvgQuickSearch, null); };
var IconQuickView = function (props) { return React.createElement(SvgQuickView, null); };
var IconRange = function (props) { return React.createElement(SvgRange, null); };
var IconReceivedCall = function (props) { return React.createElement(SvgReceivedCall, null); };
var IconReceivedEmail = function (props) { return React.createElement(SvgReceivedEmail, null); };
var IconReceivedText = function (props) { return React.createElement(SvgReceivedText, null); };
var IconReplyAll = function (props) { return React.createElement(SvgReplyAll, null); };
var IconReply = function (props) { return React.createElement(SvgReply, null); };
var IconRestore = function (props) { return React.createElement(SvgRestore, null); };
var IconRightCaret = function (props) { return React.createElement(SvgRightCaret, null); };
var IconSave = function (props) { return React.createElement(SvgSave, null); };
var IconSearch = function (props) { return React.createElement(SvgSearch, null); };
var IconSectionCollapse = function (props) { return React.createElement(SvgSectionCollapse, null); };
var IconSectionExpand = function (props) { return React.createElement(SvgSectionExpand, null); };
var IconSecurity = function (props) { return React.createElement(SvgSecurity, null); };
var IconSeeMore = function (props) { return React.createElement(SvgSeeMore, null); };
var IconSelectAll = function (props) { return React.createElement(SvgSelectAll, null); };
var IconSendAll = function (props) { return React.createElement(SvgSendAll, null); };
var IconSend = function (props) { return React.createElement(SvgSend, null); };
var IconSentCall = function (props) { return React.createElement(SvgSentCall, null); };
var IconSentEmail = function (props) { return React.createElement(SvgSentEmail, null); };
var IconSentText = function (props) { return React.createElement(SvgSentText, null); };
var IconService = function (props) { return React.createElement(SvgService, null); };
var IconSettings = function (props) { return React.createElement(SvgSettings, null); };
var IconSortAZReverse = function (props) { return React.createElement(SvgSortAZReverse, null); };
var IconSortAZ = function (props) { return React.createElement(SvgSortAZ, null); };
var IconStop = function (props) { return React.createElement(SvgStop, null); };
var IconSubMenu = function (props) { return React.createElement(SvgSubMenu, null); };
var IconSummaryView = function (props) { return React.createElement(SvgSummaryView, null); };
var IconToDo = function (props) { return React.createElement(SvgToDo, null); };
var IconUndock = function (props) { return React.createElement(SvgUndock, null); };
var IconUnknown = function (props) { return React.createElement(SvgUnknown, null); };
var IconViewAll = function (props) { return React.createElement(SvgViewAll, null); };
var IconViewFeatures = function (props) { return React.createElement(SvgViewFeatures, null); };
var IconVolumeDown = function (props) { return React.createElement(SvgVolumeDown, null); };
var IconVolumeUp = function (props) { return React.createElement(SvgVolumeUp, null); };
var IconWarning = function (props) { return React.createElement(SvgWarning, null); };

export { IconAdd, IconAddCircle, IconAddPhoto, IconAddVideoMedia, IconAddress, IconAsterisk, IconAttach, IconBack, IconBadgeDown, IconBadgeUp, IconCalendar, IconCalendarView, IconCheckboxChecked, IconCheckboxUnchecked, IconCircle, IconClose, IconCloseAllTabs, IconCollapseMinus, IconColumnHandle, IconColumnSortDown, IconColumnSortUp, IconDefaultUserImage, IconDelete, IconDeselectAll, IconDetailView, IconDock, IconDollar, IconDone, IconDropDown, IconDropDownReverse, IconEdit, IconEmail, IconEmailRead, IconEmailReadRecipient, IconEmailUnread, IconEquals, IconErase, IconError, IconExpand, IconExpandPlus, IconExport, IconFilter, IconForward, IconFullScreen, IconGraphView, IconGreaterThan, IconHalfScreen, IconHelp, IconHistory, IconHome, IconIdentification, IconImpersonate, IconInformation, IconInstantMessages, IconLeftCaret, IconLessThan, IconList, IconListen, IconLogout, IconMenu, IconMessages, IconMinimize, IconMultiselect, IconMute, IconNewEmail, IconPause, IconPhoneCall, IconPieChart, IconPlay, IconPrint, IconPrintPreview, IconQuickLinks, IconQuickSearch, IconQuickView, IconRange, IconReceivedCall, IconReceivedEmail, IconReceivedText, IconReply, IconReplyAll, IconRestore, IconRightCaret, IconSave, IconSearch, IconSectionCollapse, IconSectionExpand, IconSecurity, IconSeeMore, IconSelectAll, IconSend, IconSendAll, IconSentCall, IconSentEmail, IconSentText, IconService, IconSettings, IconSortAZ, IconSortAZReverse, IconStop, IconSubMenu, IconSummaryView, IconToDo, IconUndock, IconUnknown, IconViewAll, IconViewFeatures, IconVolumeDown, IconVolumeUp, IconWarning };
